
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eTGQR", function(module, exports) {

$parcel$export(module.exports, "fillSeriesHelper", () => $ad8771315edf3e8d$export$130cd31e321c0a8a);
$parcel$export(module.exports, "fillRandomHelper", () => $ad8771315edf3e8d$export$d9487c055432b9ce);
$parcel$export(module.exports, "shapeFillInterleaveHelper", () => $ad8771315edf3e8d$export$1f1fe46bb3d573e8);
$parcel$export(module.exports, "makeRadiatingCurves", () => $ad8771315edf3e8d$export$dd04ae150206629a);

var $dswaN = parcelRequire("dswaN");

var $hAaTb = parcelRequire("hAaTb");

var $kxhd0 = parcelRequire("kxhd0");

var $cWGjj = parcelRequire("cWGjj");

var $jBA5Z = parcelRequire("jBA5Z");

var $59COC = parcelRequire("59COC");

var $1QHbT = parcelRequire("1QHbT");

var $2sKOL = parcelRequire("2sKOL");

var $13gvI = parcelRequire("13gvI");

var $zfzWD = parcelRequire("zfzWD");

var $dWHG1 = parcelRequire("dWHG1");

var $eWODf = parcelRequire("eWODf");

var $anYB9 = parcelRequire("anYB9");

var $c9nt8 = parcelRequire("c9nt8");

var $6sTcQ = parcelRequire("6sTcQ");
// Functions here are meant to expedite filling shapes with various patterns
// or using the various other decoration classes.  
// They should all return just the resulting fill to make things simple
let $ad8771315edf3e8d$export$6d72b812a01d656b = function(shape, groups, gaps, sweep, size = [
    1
], offsets = [
    0
]) {
    let shapePatternGroups = new (0, $hAaTb.ShapeConnectGroups)(shape);
    let connectGroupArgs = new (0, $dswaN.ConnectingGroupArgs)();
    offsets = offsets.length === groups.length ? offsets : Array(groups.length).fill(offsets[0]);
    connectGroupArgs.setGroups(groups).setGroupGaps(gaps).setGroupArcs(sweep.map((val)=>[
            val,
            val
        ])).setGroupOffsets(offsets);
    if (size.some((val, idx, arr)=>val !== 0)) connectGroupArgs.setGroupSizes(size.map((val)=>[
            val,
            val
        ]));
    let [connectingShapes, pts] = shapePatternGroups.getConnectingGroups(connectGroupArgs);
    return connectingShapes;
};
let $ad8771315edf3e8d$export$ece6e0ecbac1b094 = function(shape, arc, step, size, gap, maxConnect = 0, arcChange = [
    0,
    0
], stepChange = [
    0,
    0
], sizeChange = [
    0,
    0
], arcAdjust = [
    1,
    1
], arcChangeRepeat = [
    [
        1,
        1
    ]
], stepChangeRepeat = [
    [
        1,
        1
    ]
]) {
    let shapeConnectSeries = new (0, $eWODf.ShapeConnectSeries)(shape);
    let connectSeriesArgs = new (0, $dWHG1.ConnectingSeriesArgs)(arc, step, size, gap);
    connectSeriesArgs.setArcChange(arcChange).setStepChange(stepChange).setSizeChange(sizeChange).setArcAdjust(arcAdjust).setArcChangeRepeat(arcChangeRepeat).setStepChangeRepeat(stepChangeRepeat);
    if (maxConnect > 0) connectSeriesArgs.setMaxConnect(maxConnect);
    let [connectingShapes, pts] = shapeConnectSeries.getConnecting(connectSeriesArgs);
    return connectingShapes;
};
const $ad8771315edf3e8d$export$130cd31e321c0a8a = function(shape, curveCount, maxLayers, thickness, coverage, centerPt, change = 0, rotation = 0, offset = 0, smooth = false, spacing = 0, sizeFactors = [
    1,
    1
]) {
    let shapeFillSeries = new (0, $cWGjj.ShapeFillSeries)(shape);
    let shapeFillSeriesArgs = new (0, $kxhd0.ShapeFillSeriesArgs)(curveCount, offset, maxLayers, thickness, coverage, centerPt);
    shapeFillSeriesArgs.setChange(change).setSmooth(smooth).setRotation(rotation).setSpacing(spacing).setSizeFactors(sizeFactors);
    let [connectingShapes, pts] = shapeFillSeries.fillShape(shapeFillSeriesArgs);
    return connectingShapes;
};
const $ad8771315edf3e8d$export$d9487c055432b9ce = function(shape, centerPt, layers, coverage, thickness, curveRange = [
    3,
    6
], sizeFactors = [
    2,
    4
], coverageRange = [
    2,
    4
], change = 0, spacing = 0, disjointProtection = false, resolution = 0.01) {
    let shapeFillRandom = new (0, $c9nt8.ShapeFillRandom)(shape, centerPt);
    let shapeFillRandomArgs = new (0, $anYB9.ShapeFillRandomArgs)(layers, coverage, thickness, curveRange);
    shapeFillRandomArgs.setSizeFactors(sizeFactors).setCoverageRange(coverageRange).setChange(change).setSpacing(spacing).setDisjointProtection(disjointProtection).setHiRes(resolution);
    let [connectingShapes, pts] = shapeFillRandom.fillShapeRandomArcs(shapeFillRandomArgs);
    return connectingShapes;
};
let $ad8771315edf3e8d$export$9cd0eb036c650e3e = function(shape, groups, centers, groupRadii, groupSweep, groupRadiusRepeat = [
    [
        1,
        1
    ]
], groupSweepRepeat = [
    [
        1,
        1
    ]
], centered = true) {
    let shapeRadialGroups = new (0, $59COC.ShapeRadialGroups)(shape);
    let radialGroupArgs = new (0, $jBA5Z.ShapeRadialGroupArgs)();
    radialGroupArgs.setGroups(groups).setCenterPts(centers).setIsCentered(centered).setGroupRadii(groupRadii).setGroupArcs(groupSweep).setRadiusChangeRepeat(groupRadiusRepeat).setSizeChangeRepeat(groupSweepRepeat);
    let connectingShapes = shapeRadialGroups.getRadials(radialGroupArgs);
    return connectingShapes;
};
let $ad8771315edf3e8d$export$d7bdc4ec817b38fe = function(shape, arc, step, radius, centerPt, arcChangeRepeat = [
    1,
    1
], radiusChangeRepeat = [
    1,
    1
], maxRadials = 0) {
    let shapeRadialSeries = new (0, $zfzWD.ShapeRadialSeries)(shape);
    let radialSeriesArgs = new (0, $13gvI.ShapeRadialSeriesArgs)(arc, step, radius);
    radialSeriesArgs.setCenterPt(centerPt).setArcChangeRepeat(arcChangeRepeat).setRadiusChangeRepeat(radiusChangeRepeat);
    if (maxRadials > 0) radialSeriesArgs.setMaxRadials(maxRadials);
    let connectingShapes = shapeRadialSeries.getRadials(radialSeriesArgs);
    return connectingShapes;
};
let $ad8771315edf3e8d$export$1f1fe46bb3d573e8 = function(shape, curveCount, maxLayers, thickness, coverage, centerPt, innerPct = 0.5, alternateDiff = 0.5, rotation = 0, spacing = [
    0,
    0
]) {
    let shapeFillInterleave = new (0, $2sKOL.ShapeFillInterleave)(shape);
    let interleaveArgs = new (0, $1QHbT.ShapeFillInterleaveArgs)(curveCount, maxLayers, thickness, coverage, centerPt);
    interleaveArgs.setInnerPct(innerPct).setAlternateDiff(alternateDiff).setRotation(rotation).setSpacing(spacing);
    let [shapes, pts] = shapeFillInterleave.fillShape(interleaveArgs);
    return shapes;
};
// Create radiating bands to serve as a flourish when hovering a link
const $ad8771315edf3e8d$export$dd04ae150206629a = function(draw, centerPt, circleRadius, layers, coverage, thickness, hsl, hslVary, id, gap = 0.035) {
    const centerCircle = new (0, $6sTcQ.ParameterCircle)(centerPt.x, centerPt.y, circleRadius);
    const randomCurves = $ad8771315edf3e8d$export$d9487c055432b9ce(centerCircle, centerCircle.centerPt, layers, coverage, thickness, [
        3,
        5
    ], [
        3,
        5
    ], [
        1,
        1
    ], 0, gap);
    const styleFill = new Map([
        [
            'fill-opacity',
            0.9
        ],
        [
            'fill',
            'hsl(336, 30, 93, 1.0)'
        ],
        [
            'stroke',
            'none'
        ]
    ]);
    const [curveGroup, curveRadiateIds] = draw.drawPathsColorSequenceRand(`link-radiate-curves-${id}`, randomCurves, styleFill, false, hsl, hslVary, 0.33, 'fill');
    return {
        'fillIds': curveRadiateIds,
        'fillGroup': curveGroup
    };
};

});
parcelRegister("dswaN", function(module, exports) {

$parcel$export(module.exports, "ConnectingGroupArgs", () => $9cc6d8c9ddd5647f$export$9d9020378280eccb);
class $9cc6d8c9ddd5647f$export$9d9020378280eccb {
    // Connecting shape from one point on a shape to another
    // using groups with different parameters
    //
    //// Size adjustments - if you want the arc size scaling to 
    //   be different than the groupSize values (multiplied by that)
    //
    // arcAdjust  - Arr[Number] {2} Normally the arc will draw full size
    //              but you may want to configure this.
    //
    //// Repeat adjustments for even counts TODO - 
    //
    // evenFull   - default False. Determines if even counts should attempt
    //              to cover the whole circle, because they 
    //              cause overlap problems in most cases.
    //
    //// Randomization arguments
    // arcChangeRepeat - n x 2 - repeat some sort of grow/shrink of the arcs
    //
    //// Group variables - used to draw discrete groups 
    //   with changes applied between group draws
    //
    // groups      - Array of number. Only apply the various attenutations
    //               after a group of specified size each time. 
    //               Uses an array so the size can change
    //
    // groupGaps    - Array of number. Resets the gap between the end points
    //               to this value after each groupSize.
    //               Should only be used with groupSize, otherwise it
    //               won't be applied.  
    // 
    // groupArc   - 2D Array of numbers used to reconfigure the arc 
    //              size for each group
    // groupSize  - 2D Array of numbers for the connecting shape length
    //
    // groupOffset - Offset the start point for the group by this amount,
    //               otherwise they start at an auto-calculated point
    //
    //// Other args -
    //   connectPoints - use straight lines instead of trying to use curves.
    //
    constructor(){
        this.connectPoints = false;
        this.arcAdjust = [
            1,
            1
        ];
        this.arcChangeRepeat = [
            [
                1,
                1
            ]
        ];
        this.groups = [];
        this.groupSizes = [];
        this.groupArcs = [];
        this.groupGaps = [];
        this.groupOffsets = [];
    }
    // Setters
    setArcAdjust(adjust) {
        this.arcAdjust = adjust;
        return this;
    }
    setArcChangeRepeat(repeats) {
        this.arcChangeRepeat = repeats;
        return this;
    }
    setConnectPoints(connect) {
        this.connectPoints = connect;
        return this;
    }
    setGroups(groups) {
        this.groups = groups;
        return this;
    }
    setGroupGaps(groupGaps) {
        this.groupGaps = groupGaps;
        return this;
    }
    setGroupOffsets(groupOffsets) {
        this.groupOffsets = groupOffsets;
        return this;
    }
    setGroupArcs(groupArcs) {
        this.groupArcs = groupArcs;
        return this;
    }
    setGroupSizes(groupSizes) {
        this.groupSizes = groupSizes;
        return this;
    }
    // Getters
    getGroups() {
        return this.groups.slice(0);
    }
    getGroupGaps() {
        return this.groupGaps.slice(0);
    }
    getGroupOffsets() {
        return this.groupOffsets.slice(0);
    }
    getGroupArcs() {
        return this.groupArcs.slice(0);
    }
    getGroupSizes() {
        return this.groupSizes.slice(0);
    }
}

});

parcelRegister("hAaTb", function(module, exports) {

$parcel$export(module.exports, "ShapeConnectGroups", () => $ccce3ecf1c64a624$export$b2f3f4ed824b0a49);

var $6vtqm = parcelRequire("6vtqm");
class $ccce3ecf1c64a624$export$b2f3f4ed824b0a49 {
    constructor(shape){
        this.shape = shape;
    }
    // When doing groups, completely change the method and automatically 
    // calculate things instead of trying to do mental math to make it 
    // all line up
    getShapeOuterParamsGroup(args) {
        let outerParams = [];
        let gaps = args.getGroupGaps();
        let offsets = args.getGroupOffsets();
        offsets = offsets.length > 0 ? offsets : Array(gaps.length).fill(0);
        let arcs = args.getGroupArcs();
        let originalStart = [
            0 + offsets[0],
            gaps[0] + offsets[0]
        ];
        let start, end, prevStart, arc, step;
        for (let g of args.getGroups()){
            // Stuff to do before creating the group
            // To configure or reconfigure
            let offset = offsets.shift();
            prevStart = gaps.length > 0 ? [
                0 + offset,
                gaps.shift() + offset
            ] : originalStart;
            // If you ask for an even number, changes the calc to give 
            // that many separate connectors. 
            // If just doing 1 / g, they overlap and you get 1/2
            step = g % 2 === 0 ? 1 / g / 2 : 1 / g;
            arc = arcs.length > 0 ? arcs.shift() : arc;
            outerParams.push([]);
            for(let i = 0; i < g; i++)for(let i = 0; i < 2; i++){
                start = (0, $6vtqm.roundDecimalPlaces)(prevStart[i] + step, 4);
                end = (0, $6vtqm.roundDecimalPlaces)(start + arc[i], 4);
                outerParams.at(-1).push(start, end);
                prevStart[i] = start;
            }
        }
        return outerParams;
    }
    getConnectingPointsGroup(args, outerParams) {
        let curvePoints = [];
        // Extents are analogous to the distances but serve to tell 
        // the shapes involved how to scale the relative arcs
        let extents = [];
        let sizes = args.getGroupSizes();
        let size = sizes.length > 0 ? sizes.at(0) : [
            1,
            1
        ];
        for (let groupParams of outerParams){
            // Do anything needed for group configuration here
            size = sizes.length > 0 ? sizes.shift() : size;
            for(let i = 0; i < groupParams.length; i += 4){
                extents = extents.concat([
                    size[0] * args.arcAdjust[0],
                    size[1] * args.arcAdjust[1]
                ]);
                // These point will be from higher to lower params,
                // forming the start arc of the shape
                curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, groupParams[i + 3], groupParams[i], size[0]));
                curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, groupParams[i + 2], groupParams[i + 1], size[0]));
                // and these will be from lower to higher params,
                // the end arc
                curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, groupParams[i + 1], groupParams.at(i + 2), size[1]));
                curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, groupParams[i], groupParams[i + 3], size[1]));
            }
        }
        return [
            extents,
            curvePoints
        ];
    }
    buildConnecting(args, shape, points, params, extent) {
        let path = ``;
        // Go to start
        path = `${path} M ${points[0].x} ${points[0].y} `;
        // Draw arc for lower param edge of the shape
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(0, 2), extent[0])} `;
        // Go to start of outer arc
        path = `${path} L ${points[2].x} ${points[2].y} `;
        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[3].x} ${points[3].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(2, 4), extent[1])} `;
        // Line back to start
        path = `${path} L ${points[0].x} ${points[0].y} `;
        return path;
    }
    getConnectingShapesGroups(args, outerParams, curvePoints, extents) {
        let shapePaths = [];
        for(let i = 0; i < curvePoints.length - 3; i += 4){
            let points = curvePoints.slice(i, i + 4);
            let params = outerParams.slice(i, i + 4);
            let extent = extents.slice(i / 2, i / 2 + 2);
            shapePaths.push(this.buildConnecting(args, this.shape, points, params, extent));
        }
        return shapePaths;
    }
    getConnectingGroups(args) {
        let outerParams = this.getShapeOuterParamsGroup(args);
        let [extents, curvePoints] = this.getConnectingPointsGroup(args, outerParams);
        let connectingShapes = this.getConnectingShapesGroups(args, outerParams.flat(), curvePoints, extents);
        let groupedShapes = [];
        for (let group of args.groups){
            groupedShapes.push([]);
            for(let i = 0; i < group; i++)groupedShapes.at(-1).push(connectingShapes.shift());
        }
        return [
            groupedShapes,
            curvePoints
        ];
    }
}

});
parcelRegister("6vtqm", function(module, exports) {

$parcel$export(module.exports, "roundDecimalPlaces", () => $4bcc76580b05f6e0$export$ad7faaf334f1ad94);
$parcel$export(module.exports, "distancePt", () => $4bcc76580b05f6e0$export$46d33253281b8808);
$parcel$export(module.exports, "distanceConnect", () => $4bcc76580b05f6e0$export$13c6f40ea69a9f3b);
$parcel$export(module.exports, "getPointDistance", () => $4bcc76580b05f6e0$export$e44f22c4d9681caa);
$parcel$export(module.exports, "randomAdjustment", () => $4bcc76580b05f6e0$export$dd2c3b07ba5db8ec);
$parcel$export(module.exports, "randomFromRange", () => $4bcc76580b05f6e0$export$c7cb63db9187e9a3);
$parcel$export(module.exports, "randomWholeFromRange", () => $4bcc76580b05f6e0$export$e29f8836794ebb30);
$parcel$export(module.exports, "getCenterPt", () => $4bcc76580b05f6e0$export$f788b99f350837f5);
$parcel$export(module.exports, "determineCurveBend", () => $4bcc76580b05f6e0$export$10c616ed6618edfa);
$parcel$export(module.exports, "preDetermineCurveBend", () => $4bcc76580b05f6e0$export$133cc53640de7fe);
$parcel$export(module.exports, "ensureIsArray", () => $4bcc76580b05f6e0$export$ae61df93f6b088d);
// Round to the provided number of decimals.
// Must be a positive integer or zero.
let $4bcc76580b05f6e0$export$ad7faaf334f1ad94 = function(value, decPlaces) {
    decPlaces = decPlaces <= 0 ? 0 : Math.round(decPlaces);
    let factor = decPlaces == 0 ? 1 : 10 ** decPlaces;
    return Math.round(value * factor) / factor;
};
let $4bcc76580b05f6e0$export$46d33253281b8808 = function(shape, centerPt, param, distance) {
    let cx = centerPt.x;
    let cy = centerPt.y;
    let startPt = {
        'x': cx,
        'y': cy
    };
    let endPt = shape.getCoordinates(param);
    return {
        'x': $4bcc76580b05f6e0$export$ad7faaf334f1ad94((endPt.x - startPt.x) * distance + startPt.x, 3),
        'y': $4bcc76580b05f6e0$export$ad7faaf334f1ad94((endPt.y - startPt.y) * distance + startPt.y, 3)
    };
};
let $4bcc76580b05f6e0$export$13c6f40ea69a9f3b = function(shape, startParam, endParam, distance) {
    let startPt = shape.getCoordinates(startParam);
    // {'x': cx, 'y': cy}
    let endPt = shape.getCoordinates(endParam);
    return {
        'x': $4bcc76580b05f6e0$export$ad7faaf334f1ad94((endPt.x - startPt.x) * distance + startPt.x, 3),
        'y': $4bcc76580b05f6e0$export$ad7faaf334f1ad94((endPt.y - startPt.y) * distance + startPt.y, 3)
    };
};
// This distance between two points
let $4bcc76580b05f6e0$export$e44f22c4d9681caa = function(pt1, pt2) {
    return Math.sqrt((pt1.x - pt2.x) ** 2 + (pt1.y - pt2.y) ** 2);
};
let $4bcc76580b05f6e0$export$8b958c8ecd94a804 = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
// Take the valueRange and use it to generate a number
// range is min / mid to max / mid,
// so for 5 ... 30, this is 5 / 17.5  to 30 / 17.5
let $4bcc76580b05f6e0$export$dd2c3b07ba5db8ec = function(valueRange) {
    let mid = (Math.max(...valueRange) - Math.min(...valueRange)) / 2 + Math.min(...valueRange);
    mid = mid === 0 ? 1 : mid;
    let value = $4bcc76580b05f6e0$export$8b958c8ecd94a804(...valueRange) / mid;
    return value;
};
const $4bcc76580b05f6e0$export$c7cb63db9187e9a3 = function(min, max) {
    return Math.random() * (max - min) + min;
};
const $4bcc76580b05f6e0$export$e29f8836794ebb30 = function(min, max) {
    return Math.round(Math.random() * (max - min) + min);
};
// Takes two x/y points, calculates the center point between those two. 
// needed for determining where to place ctrl points
let $4bcc76580b05f6e0$export$f788b99f350837f5 = function(ptOne, ptTwo) {
    let xDiff = ptTwo.x - ptOne.x;
    let yDiff = ptTwo.y - ptOne.y;
    return {
        'x': ptOne.x + xDiff / 2,
        'y': ptOne.y + yDiff / 2
    };
};
let $4bcc76580b05f6e0$export$31799946c693a4dd = function(ptOne, ptTwo) {
    return {
        'xDiff': ptTwo.x - ptOne.x,
        'yDiff': ptTwo.y - ptOne.y
    };
// return {'xDiff': ptOne.x - ptTwo.x, 'yDiff': ptOne.y - ptTwo.y}
};
// Slope of the line
let $4bcc76580b05f6e0$export$4fd8bb1a7f3a1e57 = function(diffs) {
    if (diffs.yDiff === 0) return 0;
    if (diffs.xDiff === 0) return Infinity;
    return diffs.yDiff / diffs.xDiff;
};
// Slope of the perpendicular line
// used to determine where to place the off center points
let $4bcc76580b05f6e0$var$getPerpenSlope = function(slope) {
    if (slope === Infinity) return 0;
    if (slope === 0) return Infinity;
    return -(1 / slope);
};
// Get the angle between two lines with the slope only
let $4bcc76580b05f6e0$export$b419e1af8fe54973 = function(slope1, slope2) {
    return $4bcc76580b05f6e0$export$ad7faaf334f1ad94(Math.abs(Math.atan((slope2 - slope1) / (1 + slope1 * slope2))), 4);
};
// Get angles in a triangle using law of cosines -
// Uses the lengths of all sides, but has no angle requirement.  
// sideA is opposite, sideC/B are on either side of the angle
let $4bcc76580b05f6e0$export$f8c7d6c2423d9124 = function(sideA, sideB, sideC) {
    let angleRads = Math.acos((sideB ** 2 + sideC ** 2 - sideA ** 2) / (2 * sideB * sideC));
    return angleRads;
};
let $4bcc76580b05f6e0$var$rotationCalc = function(pt1, pt2, pt3) {
    let val = (pt2.y - pt1.y) * (pt3.x - pt2.x) - (pt2.x - pt1.x) * (pt3.y - pt2.y);
    if (val == 0) return 'neither';
    return val > 0 ? 'clock' : 'counter';
};
// Two vectors, (pt1 -> pt2) and (pt1 -> pt3)
// calculate the vectors, then do the 
// cross product.  
// The result is the area of the parallelogram between, 
// with a Positive value if V2 is counterclock from V1, and 
// negative otherwise
// pt1 needs to always stay the same in these calcs
let $4bcc76580b05f6e0$var$crossProd = function(pt1, pt2, pt3) {
    let v1x = pt2.x - pt1.x;
    let v1y = pt2.y - pt1.y;
    let v2x = pt3.x - pt1.x;
    let v2y = pt3.y - pt1.y;
    return v1x * v2y - v2x * v1y;
};
// I am using the regular Cross Product 
// because I want to sort counterclockwise,
// which it does because of the reverse of coordinates in svg
// doing the regular cross product produces negatives going clockwise.
// The result should be the same however
let $4bcc76580b05f6e0$export$1bbbe972772e1865 = function(startEdge, edges) {
    return [
        startEdge,
        ...edges.sort((a, b)=>-$4bcc76580b05f6e0$var$crossProd(startEdge.center, a.center, b.center) || a.center.y - b.center.y)
    ];
};
let $4bcc76580b05f6e0$export$b99a108bd0364022 = function(startPt, points) {
    return [
        startPt,
        ...points.sort((a, b)=>-$4bcc76580b05f6e0$var$crossProd(startPt, a, b) || a.y - b.y + (a.x - b.x))
    ];
};
// These will be used to work out where to place the ctrl point. 
// Can run them through the formula to work out which direction to bend the
// line
let $4bcc76580b05f6e0$var$getOffCenterPoints = function(xDiff, yDiff, centerPt, slope, factor) {
    let recip = $4bcc76580b05f6e0$var$getPerpenSlope(slope);
    // Get the x factor for the adjustment
    if (recip === 0) // There is no y change in the reciprocal
    return [
        {
            'x': centerPt.x + xDiff * factor,
            'y': centerPt.y
        },
        {
            'x': centerPt.x - xDiff * factor,
            'y': centerPt.y
        }
    ];
    if (recip === Infinity) // There is no x change in the reciprocal
    return [
        {
            'x': centerPt.x,
            'y': centerPt.y + yDiff * factor
        },
        {
            'x': centerPt.x,
            'y': centerPt.y - yDiff * factor
        }
    ];
    // DONT NEED - you have the xDiff/yDiff, which represent run/rise, 
    // so just reverse those multiplied by the factor
    let xRecip = xDiff / recip;
    let yRecip = yDiff * recip;
    return [
        {
            'x': centerPt.x + yDiff * factor,
            'y': centerPt.y - xDiff * factor
        },
        {
            'x': centerPt.x - yDiff * factor,
            'y': centerPt.y + xDiff * factor
        }
    ];
};
// Determine a ctrl point to use to bend the 
// line outward away from the direction of turn to give a more 
// seamless appearance
let $4bcc76580b05f6e0$export$10c616ed6618edfa = function(ptOne, ptTwo, ptThree) {
    // Get the slopes and then the direction change.
    // Direction is clockwise if the change is positive, 
    // counterclockwise if negative
    let change = $4bcc76580b05f6e0$var$rotationCalc(ptOne, ptTwo, ptThree);
    // There is a well established formula for the angle of intersect
    // between lines
    let diffs1 = $4bcc76580b05f6e0$export$31799946c693a4dd(ptOne, ptTwo);
    let diffs2 = $4bcc76580b05f6e0$export$31799946c693a4dd(ptTwo, ptThree);
    let slope1 = $4bcc76580b05f6e0$export$4fd8bb1a7f3a1e57(diffs1);
    let slope2 = $4bcc76580b05f6e0$export$4fd8bb1a7f3a1e57(diffs2);
    // This is the angle between two lines formula, will likely come in 
    // use other places too.  
    let angleRads = Math.abs(Math.atan((slope2 - slope1) / (1 + slope1 * slope2)));
    // I think the max angle is 180, so scale the factor 
    // 0 - 1 based on that
    let factor = angleRads / Math.PI;
    let centerPt = $4bcc76580b05f6e0$export$f788b99f350837f5(ptOne, ptTwo);
    let offCenter = $4bcc76580b05f6e0$var$getOffCenterPoints(diffs1.xDiff, diffs1.yDiff, centerPt, slope1, factor);
    let chosenPt = centerPt;
    let direction;
    for (let offPt of offCenter){
        let rotate = $4bcc76580b05f6e0$var$rotationCalc(ptOne, ptTwo, offPt);
        if (change !== rotate) {
            chosenPt = offPt;
            direction = rotate;
            break;
        }
    }
    return [
        chosenPt,
        offCenter,
        direction,
        factor
    ];
};
// In this case have only two points, but will use an existing 
// direction and factor to bend the line. 
// Direction is just clockwise, counterclockwise, or neither
// if the points lie on a straight line.  
// Factor is how much to bend the line relative to the length 
// of the line.
let $4bcc76580b05f6e0$export$133cc53640de7fe = function(ptOne, ptTwo, direction, factor) {
    // There is a well established formula for the angle of intersect
    // between lines
    let diffs1 = $4bcc76580b05f6e0$export$31799946c693a4dd(ptOne, ptTwo);
    let slope1 = $4bcc76580b05f6e0$export$4fd8bb1a7f3a1e57(diffs1);
    let centerPt = $4bcc76580b05f6e0$export$f788b99f350837f5(ptOne, ptTwo);
    let offCenter = $4bcc76580b05f6e0$var$getOffCenterPoints(diffs1.xDiff, diffs1.yDiff, centerPt, slope1, factor);
    let chosenPt = centerPt;
    for (let offPt of offCenter){
        let rotate = $4bcc76580b05f6e0$var$rotationCalc(ptOne, ptTwo, offPt);
        if (direction == rotate) {
            chosenPt = offPt;
            direction = rotate;
            break;
        }
    }
    return [
        chosenPt,
        offCenter
    ];
};
let $4bcc76580b05f6e0$export$7eca484e6d9fd14b = function(minX, minY, maxX, maxY, numberPerSide) {
    // It will go right, top, left, bottom
    let points = [];
    let sides = new Map([
        [
            'minX',
            minX
        ],
        [
            'minY',
            minY
        ],
        [
            'maxX',
            maxX
        ],
        [
            'maxY',
            maxY
        ]
    ]);
    // Merging these with the sides map will adjust the 
    // randomizer to provide point along a single line at a time
    // offset factor is used to make sure points are not exactly the same
    // which causes problems with my edge sort/unique algos
    let off = 10000;
    let sideAdjust = [
        new Map([
            [
                'minX',
                maxX - Math.random() / off
            ]
        ]),
        new Map([
            [
                'maxY',
                minY + Math.random() / off
            ]
        ]),
        new Map([
            [
                'maxX',
                minX + Math.random() / off
            ]
        ]),
        new Map([
            [
                'minY',
                maxY - Math.random() / off
            ]
        ])
    ];
    for (let side of sideAdjust){
        let adjustedMap = new Map([
            ...sides,
            ...side
        ]).values();
        // Turning the map values into an array is lousy
        // syntax but does work, maybe turn to an array
        points.push(...$4bcc76580b05f6e0$export$1cf1ca8753a50102(...[
            ...adjustedMap
        ], numberPerSide));
    }
    return points;
};
let $4bcc76580b05f6e0$var$pointGenerator = function(minX, minY, maxX, maxY) {
    let xRange = maxX - minX;
    let yRange = maxY - minY;
    let randX = minX + Math.random() * xRange;
    let randY = minY + Math.random() * yRange;
    return {
        'x': randX,
        'y': randY
    };
};
let $4bcc76580b05f6e0$export$1cf1ca8753a50102 = function(minX, minY, maxX, maxY, number) {
    let points = [];
    for(let i = 0; i < number; i++)points.push($4bcc76580b05f6e0$var$pointGenerator(minX, minY, maxX, maxY));
    return points;
};
let $4bcc76580b05f6e0$export$ae61df93f6b088d = function(input) {
    if (!Array.isArray(input)) input = [
        input
    ];
    return input;
};

});


parcelRegister("kxhd0", function(module, exports) {

$parcel$export(module.exports, "ShapeFillSeriesArgs", () => $ef343d079e29c7dc$export$5432bc9413eecb69);
class $ef343d079e29c7dc$export$5432bc9413eecb69 {
    // curveCount - The number of initial outer curves to create and work
    //              with using the subsequent arguments. 
    // startParam - The param (i) to center the first curve set. Will 
    //                 Auto locate the rest. 
    // maxLayers - how many rings to add on.  
    // thickness - Thickness as a percent of the parent (will use the
    //             radius, be a percent of that)
    //             Positive thickness grows outward, negative thickness inward.
    // coverage - How much of the shape the curves should cover 
    //            at the first layer.  
    //
    //
    //// Change or adjustment parameters
    // change - How quickly to shink or grow those rings.  
    //          A percent change. Replaces attenuate since it can grow 
    //          or shrink.  
    //          Is added to 1, so usually a small negative or positive that will
    //          shrink or grow respectively.  
    // rotation - Optional argument to shift the layers moving outward. 
    //            Unlike change does not alter the size, it adjusts position
    //            rotationally. Positive is counterclock, negative clockwise. 
    // spacing - Add spacing between layers, uses same calculations
    //           as thickness
    // sizeFactors - A sequence of size adjustments to repeat
    //              They will apply to all curves in that layer.
    //              TODO: This is not actually implemented
    // smooth - Instead of stacking square layers will seek to smooth the 
    //          transition by connecting inner of current layer
    //          with inner of next layer
    constructor(curveCount, startParam, maxLayers, thickness, coverage, centerPt){
        this.curveCount = curveCount;
        this.startParam = startParam;
        this.maxLayers = maxLayers;
        this.thickness = thickness;
        this.coverage = coverage;
        this.centerPt = centerPt;
        this.change = 0;
        this.changeCompound = true;
        this.rotation = 0;
        this.spacing = 0;
        this.subSizes = [
            1
        ];
        this.sizeFactors = [
            1,
            1
        ];
        this.smooth = false;
    }
    setChange(change) {
        this.change = change;
        return this;
    }
    setChangeCompound(compound) {
        this.changeCompound = compound;
        return this;
    }
    setSpacing(spacing) {
        this.spacing = spacing;
        return this;
    }
    setRotation(rotation) {
        this.rotation = rotation;
        return this;
    }
    setSubSize(subSizes) {
        this.subSizes = subSizes;
        return this;
    }
    setSmooth(smooth) {
        this.smooth = smooth;
        return this;
    }
    setSizeFactors(sizeFactors) {
        this.sizeFactors = sizeFactors;
        return this;
    }
}

});

parcelRegister("cWGjj", function(module, exports) {

$parcel$export(module.exports, "ShapeFillSeries", () => $96cbb8ccca43ba57$export$e8244d9e40cdfb80);

var $6vtqm = parcelRequire("6vtqm");
// This class deals with filling/expanding shapes 
// based on their parameters and some arguments. 
// Will probably be most aimed at circles but can see what else it might 
// work for
class $96cbb8ccca43ba57$export$e8244d9e40cdfb80 {
    constructor(shape){
        // shape needs a getCoordinates() method for this to work.  
        // and getSubCurveRelative() method
        this.shape = shape;
    }
    getSubSizes(args) {
        let completeSize = args.coverage / args.curveCount;
        if (args.subSizes.length === 0) return Array(args.curveCount).fill(completeSize);
        else {
            let normalize = args.subSizes.reduce((a, b)=>a + b);
            let subs = args.subSizes.map((a)=>a / normalize * completeSize);
            return Array(args.curveCount).fill(subs).flat();
        }
    }
    getSwirlOffset(args, i) {
        return args.rotation * i + args.startParam;
    }
    getPadLength(args, curveCoverage) {
        let padLengths = [];
        let blankSize = 1 - curveCoverage;
        if (args.subSizes.length > 1) {
            for(let i = 0; i < args.curveCount; i++)for (let sub of args.subSizes)padLengths.push(blankSize / args.curveCount * sub);
        } else padLengths = Array(args.curveCount).fill(blankSize / args.curveCount);
        return padLengths;
    }
    // Based on the inputs, calculate the center points (1 dim arr)
    // for all of the curves, and then all the curve points moving outward 
    // in a 2-dim array, with pairs in that array representing the 
    // curves endpoints in an outward progression.  
    getDistanceParams(args) {
        let centerParams = [];
        let endParams = [];
        let padLengths = this.getPadLength(args, args.coverage);
        let allCurveSizes = this.getSubSizes(args);
        let originalCurveSizes = allCurveSizes.slice(0);
        for(let i = 0; i < args.maxLayers; i++){
            let startOffset = this.getSwirlOffset(args, i);
            let sizeFactor = args.sizeFactors[i % args.sizeFactors.length];
            centerParams.push([]);
            endParams.push([]);
            let prevParam = startOffset;
            let n = 0;
            for (let size of allCurveSizes){
                size;
                let start = padLengths[n] / 2 + prevParam;
                let center = size * sizeFactor / 2 + start;
                centerParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(center, 5));
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(start, 5));
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(start + size * sizeFactor, 5));
                prevParam = start + size + padLengths[n] / 2;
                n++;
            }
            if (args.changeCompound) allCurveSizes = allCurveSizes.map((size)=>size * (1 + args.change));
            else allCurveSizes = originalCurveSizes.map((size)=>size * (1 + args.change * (i + 1)));
            padLengths = this.getPadLength(args, allCurveSizes.reduce((a, b)=>a + b));
        }
        return [
            centerParams,
            endParams
        ];
    }
    // The curve points are a 3 dim array to account for being 
    // different for each input shape, while the params will be the same 
    // for each of them
    getCurvePoints(endsParams, args) {
        let curvePoints = [];
        let distance = 1;
        for (let params of endsParams){
            curvePoints.push([]);
            for(let i = 0; i < params.length - 1; i += 2){
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i + 1), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i + 1), distance + args.thickness));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i), distance + args.thickness));
            }
            distance += args.thickness + args.spacing;
        }
        return curvePoints;
    }
    // TODO: If I can get true 'smooth' using a bezier, that would
    //       be neat. Likely need to sort out how to draw line at angle 
    //       from line regardless of orientation however.
    buildCurve(pointArr, paramsIn, paramsOut, sizeArr, connectPoints) {
        let path = ``;
        let [startInnerPt, endInnerPt, startOuterPt, endOuterPt] = pointArr;
        let [sizeInner, sizeOuter] = sizeArr;
        // Go to start
        path = `${path} M ${startInnerPt.x} ${startInnerPt.y} `;
        // draw to inner arc end
        path = connectPoints ? `${path} L ${endInnerPt.x} ${endInnerPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsIn, sizeInner)} `;
        // line to outer arc start
        path = `${path} L ${startOuterPt.x} ${startOuterPt.y} `;
        // draw outer arc
        path = connectPoints ? `${path} L ${endOuterPt.x} ${endOuterPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsOut.reverse(), sizeOuter)} `;
        // line back to start point
        path = `${path} L ${startInnerPt.x} ${startInnerPt.y} `;
        return path;
    }
    getLayerShapes(curvePoints, endParams, args) {
        let shapePaths = [];
        let n = 1;
        for (let layerPoints of curvePoints){
            let layerParams = endParams.at(n - 1);
            let sizeInner = 1 + (n - 1) * (args.thickness + args.spacing);
            let sizeOuter = 1 + (n * args.thickness + (n - 1) * args.spacing);
            for(let i = 0; i < layerPoints.length - 3; i += 4){
                let params = layerParams.slice(i / 2, i / 2 + 2);
                let points = layerPoints.slice(i, i + 4);
                shapePaths.push(this.buildCurve(points, params, params, [
                    sizeInner,
                    sizeOuter
                ], false));
            }
            n++;
        }
        return shapePaths;
    }
    buildSmoothCurve(pointArr, ctrlPoints, paramsIn, paramsOut, sizeArr, connectPoints) {
        let path = ``;
        let [startInnerPt, endInnerPt, startOuterPt, endOuterPt] = pointArr;
        let [sizeInner, sizeOuter] = sizeArr;
        let [ctrlOne, ctrlTwo] = ctrlPoints;
        // Go to start
        path = `${path} M ${startInnerPt.x} ${startInnerPt.y} `;
        // draw to inner arc end
        path = connectPoints ? `${path} L ${endInnerPt.x} ${endInnerPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsIn, sizeInner)} `;
        // draw the bezier from first arc end to second arc start
        path = `${path} Q ${ctrlOne.x} ${ctrlOne.y} ${startOuterPt.x} ${startOuterPt.y} `;
        // path = `${path} L ${startOuterPt.x} ${startOuterPt.y} `
        // draw outer arc
        path = connectPoints ? `${path} L ${endOuterPt.x} ${endOuterPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsOut.reverse(), sizeOuter)} `;
        // line back to start point
        path = `${path} Q ${ctrlTwo.x} ${ctrlTwo.y} ${startInnerPt.x} ${startInnerPt.y} `;
        // path = `${path} L ${startInnerPt.x} ${startInnerPt.y} `
        return path;
    }
    continueSmoothCurve(pointArr, ctrlPoints, paramsIn, paramsOut, sizeArr, connectPoints) {
        let path = ``;
        let [startInnerPt, endInnerPt, startOuterPt, endOuterPt] = pointArr;
        let [sizeInner, sizeOuter] = sizeArr;
        let [ctrlOne, ctrlTwo] = ctrlPoints;
        // Go to start
        path = `${path} M ${startInnerPt.x} ${startInnerPt.y} `;
        // draw to inner arc end
        path = connectPoints ? `${path} L ${endInnerPt.x} ${endInnerPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsIn, sizeInner)} `;
        // draw the bezier from first arc end to second arc start
        path = `${path} T ${startOuterPt.x} ${startOuterPt.y} `;
        // path = `${path} L ${startOuterPt.x} ${startOuterPt.y} `
        // draw outer arc
        path = connectPoints ? `${path} L ${endOuterPt.x} ${endOuterPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsOut.reverse(), sizeOuter)} `;
        // line back to start point
        path = `${path} T ${startInnerPt.x} ${startInnerPt.y} `;
        // path = `${path} L ${startInnerPt.x} ${startInnerPt.y} `
        return path;
    }
    // Need to always pair inner/inner, 
    // and then skip the last outer since that would lead to one awkward 
    // square layer on top.
    getSmoothShapes(curvePoints, endParams, args) {
        let shapePaths = [];
        let n = 1;
        let debugPoints = [];
        let preDeterminePrev = [];
        for(let i = 0; i < curvePoints.length - 1; i++){
            let currentPoints = curvePoints[i];
            let nextPoints = curvePoints[i + 1];
            let beyondPoints = [];
            let preDetermine = [];
            if (i + 2 < curvePoints.length - 1) beyondPoints = curvePoints[i + 2];
            let currentParams = endParams[i];
            let nextParams = endParams[i + 1];
            let sizeInner = 1 + (n - 1) * (args.thickness + args.spacing);
            let sizeOuter = 1 + (n * args.thickness + (n - 1) * args.spacing);
            for(let k = 0; k < currentPoints.length - 3; k += 4){
                let paramsIn = currentParams.slice(k / 2, k / 2 + 2);
                let paramsOut = nextParams.slice(k / 2, k / 2 + 2);
                let ctrlPoints = [];
                let points = currentPoints.slice(k, k + 2);
                let nexts = nextPoints.slice(k, k + 2).reverse();
                // Get the control points. 
                // Uses the current, next, and one after that. 
                // If there are not enough left to use, memoized the 
                // last curve direction and uses that.
                if (beyondPoints.length > 0) {
                    let beyonds = beyondPoints.slice(k, k + 2).reverse();
                    let [ctrlPt1, debugPts1, dir1, fac1] = (0, $6vtqm.determineCurveBend)(points[1], nexts[0], beyonds[0]);
                    ctrlPoints.push(ctrlPt1);
                    preDetermine.push(dir1, fac1);
                    let [ctrlPt2, debugPts2, dir2, fac2] = (0, $6vtqm.determineCurveBend)(points[0], nexts[1], beyonds[1]);
                    ctrlPoints.push(ctrlPt2);
                    preDetermine.push(dir2, fac2);
                    debugPoints = debugPoints.concat(debugPts1);
                    debugPoints = debugPoints.concat(debugPts2);
                } else {
                    ctrlPoints.push((0, $6vtqm.preDetermineCurveBend)(points[1], nexts[0], preDeterminePrev[k], preDeterminePrev[k + 1])[0]);
                    ctrlPoints.push((0, $6vtqm.preDetermineCurveBend)(points[0], nexts[1], preDeterminePrev[k + 2], preDeterminePrev[k + 3])[0]);
                }
                points.push(...nexts);
                shapePaths.push(this.buildSmoothCurve(points, ctrlPoints, paramsIn, paramsOut, [
                    sizeInner,
                    sizeOuter
                ], false));
            }
            if (preDetermine.length > 0) preDeterminePrev = preDetermine;
            n++;
        }
        return [
            shapePaths,
            debugPoints
        ];
    }
    //// Primary Method. 
    // Call this with a ShapeFillSeriesArgs object to get the 
    // desired filling shapes
    fillShape(args) {
        let [centerParams, endParams] = this.getDistanceParams(args);
        let curvePoints = this.getCurvePoints(endParams, args);
        if (args.smooth) {
            let [getLayerShapes, debugPoints] = this.getSmoothShapes(curvePoints, endParams, args);
            return [
                getLayerShapes,
                debugPoints
            ];
        } else {
            let getLayerShapes = this.getLayerShapes(curvePoints, endParams, args);
            return [
                getLayerShapes,
                curvePoints
            ];
        }
    }
}

});

parcelRegister("jBA5Z", function(module, exports) {

$parcel$export(module.exports, "ShapeRadialGroupArgs", () => $e45d78d63911661e$export$ce3fe63c60d18646);
class $e45d78d63911661e$export$ce3fe63c60d18646 {
    // Radials from center point to edges
    // The idea here is to expand a circle, but do so with shrinking 
    // outer layers. 
    //
    //// General config
    // centerPt     - Object (with x, y members).
    //              allows picking a custom center point  
    // isCentered   - Will center the radial at the current param location,
    //                insteading of having its starting edge there.
    // connectPoints - Draw straight lines between points instead of 
    //                 using the relative arcs.
    //
    //// Patterns to repeat within a group
    // arcAttenRepeat - Matrix, numbers to do a repetetive shrink/grow 
    //                   width of the radials to build patterns with
    //                   for each group.
    // attenuateRadius - Matrix (number) - array that will be repeated 
    //                   to grow/shrink the radius of radials for 
    //                   each group.
    //
    //// Grouping arguments. create shapes in groups with 
    //   changes between groups.
    // groups  - array of number. Overrides most of the above arguments and 
    //           applies only select change args after each group is complete.
    // groupArcs   - Array of number. Resets the arc size (arc sweep)
    //                of radials to the given value
    //                for groups after the initial one.  
    // groupRadii   - Array of number. Changes the radius of arcs for subsequent groups
    // groupSteps   - Array of number. Changes the step size for subsequent groups.  
    constructor(){
        this.centerPts = [];
        this.isCentered = false;
        this.connectPoints = false;
        this.arcChangeRepeat = [
            [
                1,
                1
            ]
        ];
        this.radiusChangeRepeat = [
            [
                1,
                1
            ]
        ];
        this.groups = [];
        this.groupArcs = [];
        this.groupRadii = [];
        this.groupSteps = [];
    }
    setCenterPts(centerPts) {
        this.centerPts = centerPts;
        return this;
    }
    setIsCentered(isCentered) {
        this.isCentered = isCentered;
        return this;
    }
    setConnectPoints(connect) {
        this.connectPoints = connect;
        return this;
    }
    // will add them into arc calculations in repeating fashion
    setSizeChangeRepeat(arcChangeRepeat) {
        this.arcChangeRepeat = arcChangeRepeat;
        return this;
    }
    // Take an array of two or more float, 
    // will add them into radius calculations in repeating fashion
    setRadiusChangeRepeat(radiusChangeRepeat) {
        this.radiusChangeRepeat = radiusChangeRepeat;
        return this;
    }
    setGroups(groups) {
        this.groups = groups;
        return this;
    }
    setGroupArcs(arcs) {
        this.groupArcs = arcs;
        return this;
    }
    setGroupRadii(radii) {
        this.groupRadii = radii;
        return this;
    }
    setGroupSteps(steps) {
        this.groupSteps = steps;
        return this;
    }
    getCenterPts() {
        return this.centerPts.slice(0);
    }
    getGroups() {
        return this.groups.slice(0);
    }
    getGroupArcs() {
        return this.groupArcs.slice(0);
    }
    getGroupRadii() {
        return this.groupRadii.slice(0);
    }
    getGroupSteps() {
        return this.groupSteps.slice(0);
    }
    getSweepChangeRepeat(n) {
        return this.arcChangeRepeat.length > n ? this.arcChangeRepeat[n] : this.arcChangeRepeat[0];
    }
    getRadiusChangeRepeat(n) {
        return this.radiusChangeRepeat.length > n ? this.radiusChangeRepeat[n] : this.radiusChangeRepeat[0];
    }
}

});

parcelRegister("59COC", function(module, exports) {

$parcel$export(module.exports, "ShapeRadialGroups", () => $3c0be6f7b12fe1f6$export$5c5720393f51a086);

var $6vtqm = parcelRequire("6vtqm");
class $3c0be6f7b12fe1f6$export$5c5720393f51a086 {
    constructor(shape){
        this.shape = shape;
    }
    distancePt(centerPt, param, distance) {
        let cx = centerPt.x;
        let cy = centerPt.y;
        let startPt = {
            'x': cx,
            'y': cy
        };
        let endPt = this.shape.getCoordinates(param);
        return {
            'x': (0, $6vtqm.roundDecimalPlaces)((endPt.x - startPt.x) * distance + startPt.x, 3),
            'y': (0, $6vtqm.roundDecimalPlaces)((endPt.y - startPt.y) * distance + startPt.y, 3)
        };
    }
    getOuterParamsGroup(args) {
        let outerParams = [];
        let start, end, arc, step, prevStart, changeRepeat, change;
        let arcs = args.getGroupArcs();
        let n = 0;
        for (let g of args.getGroups()){
            prevStart = 0;
            step = 1 / g;
            arc = arcs.length > 0 ? arcs.shift() : arc;
            outerParams.push([]);
            changeRepeat = args.getSweepChangeRepeat(n);
            for(let i = 0; i < g; i++){
                change = changeRepeat[i % changeRepeat.length];
                start = (0, $6vtqm.roundDecimalPlaces)(prevStart + step, 4);
                end = (0, $6vtqm.roundDecimalPlaces)(start + arc * changeRepeat, 4);
                if (args.isCentered) {
                    let neuStart = (0, $6vtqm.roundDecimalPlaces)(start + Math.abs(step - arc) / 2, 4);
                    let neuEnd = (0, $6vtqm.roundDecimalPlaces)(neuStart + arc, 4);
                    outerParams.at(-1).push(neuStart, neuEnd);
                } else outerParams.at(-1).push(start, end);
                prevStart = start;
            }
            n++;
        }
        return outerParams;
    }
    getRadialPoints(args, outerParams) {
        let curvePoints = [];
        let radii = [];
        let rads = args.getGroupRadii();
        let centerPts = args.getCenterPts();
        let rad, distance, centerPt, changeRepeat, change;
        let n = 0;
        for (let groupParams of outerParams){
            curvePoints.push([]);
            radii.push([]);
            rad = rads.length > 0 ? rads.shift() : rad;
            centerPt = centerPts.length > 0 ? centerPts.shift() : centerPt;
            for(let i = 0; i < groupParams.length - 1; i += 2){
                changeRepeat = args.getRadiusChangeRepeat(n);
                change = changeRepeat[i / 2 % changeRepeat.length];
                distance = rad * change;
                radii.at(-1).push(distance);
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, centerPt, groupParams.at(i), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, centerPt, groupParams.at(i + 1), distance));
            }
            n++;
        }
        return [
            radii,
            curvePoints
        ];
    }
    buildRadial(args, shape, points, params, radius, centerPt) {
        let path = ``;
        // Go to start
        path = `${path} M ${centerPt.x} ${centerPt.y} `;
        // Go to start of outer arc
        path = `${path} L ${points[0].x} ${points[0].y} `;
        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params, radius)} `;
        // Line back to start
        path = `${path} L ${centerPt.x} ${centerPt.y} `;
        return path;
    }
    getRadialShapes(args, outerParams, outerPoints, radii) {
        let shapePaths = [];
        let n = 0;
        let centerPts = args.getCenterPts();
        for (let paramGroup of outerParams){
            let pointGroup = outerPoints[n];
            let radiiGroup = radii[n];
            let centerPt = centerPts.length > 0 ? centerPts.shift() : centerPt;
            for(let i = 0; i < pointGroup.length - 1; i += 2){
                let points = pointGroup.slice(i, i + 2);
                let params = paramGroup.slice(i, i + 2);
                let radius = radiiGroup.at(i / 2);
                shapePaths.push(this.buildRadial(args, this.shape, points, params, radius, centerPt));
            }
            n++;
        }
        return shapePaths;
    }
    getRadials(args) {
        let outerParams = this.getOuterParamsGroup(args);
        let [radii, radialPoints] = this.getRadialPoints(args, outerParams);
        let radialShapes = this.getRadialShapes(args, outerParams, radialPoints, radii);
        return radialShapes;
    }
}

});

parcelRegister("1QHbT", function(module, exports) {

$parcel$export(module.exports, "ShapeFillInterleaveArgs", () => $158c268f58bd2f56$export$f9fefaaddbbb4135);

var $6vtqm = parcelRequire("6vtqm");
class $158c268f58bd2f56$export$f9fefaaddbbb4135 {
    // curveCount - The number of initial outer curves to create and work
    //              with using the subsequent arguments. 
    // maxLayers - how many rings to add on.  
    // thickness - [min, max] - thickness as a percent of the 
    //             parent (will use the radius, be a percent of that)
    //             If the same, will be consistent, otherwise randomized.
    // coverage - How much of the shape the curves should cover 
    //            at the first layer.  
    //
    //
    //// Change or adjustment parameters
    // change - How quickly to shink or grow those rings.  
    //          A percent change. Replaces attenuate since it can grow 
    //          or shrink.  
    // rotation - Optional argument to shift the layers moving outward. 
    //            Unlike change does not alter the size, it adjusts position
    //            rotationally. Positive is counterclock, negative clockwise. 
    // spacing - [min, max], Add spacing between layers, uses same 
    //           calculations as thickness. If values are the same 
    //           spacing will be consistent.
    // thicknessRandSize - [min, max] - 
    // alternates - Configure the ability to create a sequence of shape 
    //              sizes in a layer. the values must add to one 
    //              (or else will be normalized to 1) and then are used 
    //              to add layers sized based on those ratios 
    //              for the layer. 
    //              Exact calculations are TBD so will see how it works.  
    //
    constructor(curveCount, maxLayers, thickness, coverage, centerPt){
        this.curveCount = curveCount;
        this.maxLayers = maxLayers;
        thickness = (0, $6vtqm.ensureIsArray)(thickness);
        this.thickness = thickness.length < 2 ? Array(2).fill(thickness[0]) : thickness;
        this.coverage = coverage;
        this.centerPt = centerPt;
        this.startParam = 0;
        this.innerPct = 0;
        // This controls the size difference of the 
        // alternating pieces so that there is more contrast control
        // NOT YET IMPLEMENTED
        this.alternateDiff = 0;
        this.change = 0;
        this.changeCompound = true;
        this.rotation = 0;
        this.spacing = [
            0,
            0
        ];
        this.subSizes = [
            1
        ];
    }
    setChange(change) {
        this.change = change;
        return this;
    }
    setChangeCompound(compound) {
        this.changeCompound = compound;
        return this;
    }
    setSpacing(spacing) {
        spacing = (0, $6vtqm.ensureIsArray)(spacing);
        this.spacing = spacing.length < 2 ? Array(2).fill(spacing[0]) : spacing;
        return this;
    }
    setRotation(rotation) {
        this.rotation = rotation;
        return this;
    }
    setSubSize(subSizes) {
        this.subSizes = subSizes;
        return this;
    }
    setInnerPct(pct) {
        this.innerPct = pct;
        return this;
    }
    setAlternateDiff(diff) {
        this.alternateDiff = diff;
        return this;
    }
}

});

parcelRegister("2sKOL", function(module, exports) {

$parcel$export(module.exports, "ShapeFillInterleave", () => $1cb283559cf8ae24$export$476671d09d75d362);

var $6vtqm = parcelRequire("6vtqm");
// This class deals with filling/expanding shapes 
// based on their parameters and some arguments. 
// Will probably be most aimed at circles but can see what else it might 
// work for
class $1cb283559cf8ae24$export$476671d09d75d362 {
    constructor(shape){
        // shape needs a getCoordinates() method for this to work.  
        this.shape = shape;
    }
    getSubSizes(args) {
        let completeSize = args.coverage / args.curveCount;
        if (args.subSizes.length === 0) return Array(args.curveCount).fill(completeSize);
        else {
            let normalize = args.subSizes.reduce((a, b)=>a + b);
            let subs = args.subSizes.map((a)=>a / normalize * completeSize);
            return Array(args.curveCount).fill(subs).flat();
        }
    }
    getSwirlOffset(args, i) {
        return args.rotation * i + args.startParam;
    }
    getPadLength(args, curveCoverage) {
        let padLengths = [];
        let blankSize = 1 - curveCoverage;
        if (args.subSizes.length > 1) {
            for(let i = 0; i < args.curveCount; i++)for (let sub of args.subSizes)padLengths.push(blankSize / args.curveCount * sub);
        } else padLengths = Array(args.curveCount).fill(blankSize / args.curveCount);
        return padLengths;
    }
    addInterleavedParams() {}
    // Based on the inputs, calculate the center points (1 dim arr)
    // for all of the curves, and then all the curve points moving outward 
    // in a 2-dim array, with pairs in that array representing the 
    // curves endpoints in an outward progression.  
    getDistanceParams(args) {
        let centerParams = [];
        let endParams = [];
        let padLengths = this.getPadLength(args, args.coverage);
        let allCurveSizes = this.getSubSizes(args);
        let originalCurveSizes = allCurveSizes.slice(0);
        for(let i = 0; i < args.maxLayers; i++){
            let startOffset = this.getSwirlOffset(args, i);
            centerParams.push([]);
            endParams.push([]);
            let prevParam = startOffset;
            let n = 0;
            for (let size of allCurveSizes){
                // Setup the equation.
                // The form is:
                // outer1 + outer2 == size
                // inner1 + inner == size
                // So anything you do to either inner/outer 
                // you must make sure to exactly offset in the other.
                let equalSizes = size / 2;
                let inOutReall = equalSizes * (1 - args.innerPct);
                let outer1 = equalSizes + inOutReall;
                let outer2 = equalSizes - inOutReall;
                let inner1 = equalSizes - inOutReall;
                let inner2 = equalSizes + inOutReall;
                let altReall1 = outer2 * args.alternateDiff;
                let altReall2 = inner2 * args.alternateDiff;
                outer1 = outer1 + altReall1;
                outer2 = outer2 - altReall1;
                inner1 = inner1 + altReall2;
                inner2 = inner2 - altReall2;
                let innerOffset = (outer1 - inner1) / 2;
                let halfPad = padLengths[n] / 2;
                // The points for the first half of the shape
                // let start = halfPad + prevParam
                let start = prevParam + halfPad;
                let center = outer1 / 2 + start;
                let outer1End = start + outer1;
                centerParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(center, 5));
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(start, 5));
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(outer1End, 5));
                // points for the second half; could be inside
                // or outside the above
                // let secondSize = partSize * args.innerPct
                let innerStart = start + innerOffset;
                let inner1End = innerStart + inner1;
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(innerStart, 5));
                endParams.at(-1).push((0, $6vtqm.roundDecimalPlaces)(inner1End, 5));
                // Do the interleaving
                let interL = [];
                // The outer part of the second shape
                let outer2Start = outer1End + halfPad;
                let outer2End = outer2Start + outer2;
                interL.push(outer2Start);
                interL.push(outer2End);
                // the outer part of the second shape
                let inner2Start = inner1End + halfPad;
                interL.push(inner2Start);
                interL.push(inner2Start + inner2);
                endParams.at(-1).push(...interL);
                // Reset the start location
                prevParam = outer2End;
                n++;
            }
            if (args.changeCompound) allCurveSizes = allCurveSizes.map((size)=>size * (1 + args.change));
            else allCurveSizes = originalCurveSizes.map((size)=>size * (1 + args.change * (i + 1)));
            // Alter the pad lengths to account for size change
            let curveTotal = allCurveSizes.reduce((a, b)=>a + b);
            padLengths = this.getPadLength(args, curveTotal);
        }
        return [
            centerParams,
            endParams
        ];
    }
    // The curve points are a 3 dim array to account for being 
    // different for each input shape, while the params will be the same 
    // for each of them
    getCurvePoints(endsParams, args) {
        let curvePoints = [];
        let thicknesses = [];
        let spacings = [];
        let distance = 1;
        let n = 0;
        for (let params of endsParams){
            curvePoints.push([]);
            let thickLen = args.thickness.length;
            let spaceLen = args.spacing.length;
            let thickness = thickLen > 2 ? args.thickness[n % thickLen] : (0, $6vtqm.roundDecimalPlaces)((0, $6vtqm.randomFromRange)(...args.thickness), 3);
            let spacing = spaceLen > 2 ? args.spacing[n % spaceLen] : (0, $6vtqm.roundDecimalPlaces)((0, $6vtqm.randomFromRange)(...args.spacing), 3);
            thicknesses.push(thickness);
            spacings.push(spacing);
            for(let i = 0; i < params.length - 1; i += 4){
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i + 1), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i + 3), distance + thickness));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, args.centerPt, params.at(i + 2), distance + thickness));
            }
            distance += thickness + spacing;
            n++;
        }
        return [
            curvePoints,
            thicknesses,
            spacings
        ];
    }
    buildCurve(pointArr, paramsArc1, paramsArc2, sizeArr, connectPoints) {
        let path = ``;
        let [startInnerPt, endInnerPt, startOuterPt, endOuterPt] = pointArr;
        let [sizeInner, sizeOuter] = sizeArr;
        // Go to start
        path = `${path} M ${startInnerPt.x} ${startInnerPt.y} `;
        // draw to inner arc end
        path = connectPoints ? `${path} L ${endInnerPt.x} ${endInnerPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsArc1, sizeInner)} `;
        // line to outer arc start
        path = `${path} L ${startOuterPt.x} ${startOuterPt.y} `;
        // draw outer arc
        path = connectPoints ? `${path} L ${endOuterPt.x} ${endOuterPt.y} ` : `${path} ${this.shape.getSubCurveRelative(...paramsArc2.reverse(), sizeOuter)} `;
        // line back to start point
        path = `${path} L ${startInnerPt.x} ${startInnerPt.y} `;
        return path;
    }
    getLayerShapes(curvePoints, thicknesses, spacings, endParams, args) {
        let shapePaths = [];
        let n = 1;
        for (let layerPoints of curvePoints){
            let thicknessSum = thicknesses.slice(0, n - 1).reduce((a, b)=>a + b, 0);
            let thicknessSumCur = thicknesses.slice(0, n).reduce((a, b)=>a + b, 0);
            let spacingSum = spacings.slice(0, n - 1).reduce((a, b)=>a + b, 0);
            // let spacingSum = spacings.slice(0, n).reduce((a, b) => a + b)
            let layerParams = endParams.at(n - 1);
            let sizeInner = 1 + (thicknessSum + spacingSum);
            let sizeOuter = 1 + (thicknessSumCur + spacingSum);
            // let sizeInner = 1 + ((n - 1) * (args.thickness + args.spacing))
            // let sizeOuter = 1 + (n * args.thickness) + ((n - 1) * args.spacing)
            for(let i = 0; i < layerPoints.length - 3; i += 4){
                let paramsArc1 = layerParams.slice(i, i + 2);
                let paramsArc2 = layerParams.slice(i + 2, i + 4);
                let points = layerPoints.slice(i, i + 4);
                shapePaths.push(this.buildCurve(points, paramsArc1, paramsArc2, [
                    sizeInner,
                    sizeOuter
                ], false));
            }
            n++;
        }
        return shapePaths;
    }
    fillShape(args) {
        let [centerParams, endParams] = this.getDistanceParams(args);
        let [curvePoints, thicknesses, spacings] = this.getCurvePoints(endParams, args);
        let getLayerShapes = this.getLayerShapes(curvePoints, thicknesses, spacings, endParams, args);
        return [
            getLayerShapes,
            curvePoints
        ];
    }
}

});

parcelRegister("13gvI", function(module, exports) {

$parcel$export(module.exports, "ShapeRadialSeriesArgs", () => $0c42e0e26262cac1$export$bb45327923aee33c);
class $0c42e0e26262cac1$export$bb45327923aee33c {
    // Radials from center point to edges
    // The idea here is to expand a circle, but do so with shrinking 
    // outer layers. 
    //
    // shape - The shape to create the radials for. 
    // 
    // arc       - The arc of the outer part of the radial, 0-1.
    //              along the provided shape (so sweep).  
    //              should probably be something on the smaller side unless
    //              you want very large pie slices.  
    // step       - How much to move along the outer shape before
    //              drawing next arc. Defaults to the same value as arc.
    // radius     - How far the radials should go to the outside, 
    //              defaults to 1 (all the way).  
    // centerPt     - Object (with x, y members).
    //              allows picking a custom center point  
    // maxRadials - how many radials to add. defaults to roughly 1 full
    //              rotation of the object
    //              
    //// Randomization or grow/shrink factors
    // arcRange  - randomness range for the sizing.
    // stepRange  - randomness range to adjust how large the step is. 
    // radiusRange  - randomness range to adjust how large the radius is. 
    // arcChange    - Optional value to shrink the coverage of the 
    //                radials. positive grows, negative shrinks.
    //                Defaults to none (0). 
    // arcChangeRepeat - Array, numbers to do a repetetive shrink/grow 
    //                   width of the radials to build patterns with.
    // radiusChangeRepeat - Array (number) - array that will be repeated 
    //                   to grow/shrink the radius of radials.
    //
    constructor(arc, step, radius){
        this.arc = arc;
        this.step = step;
        this.radius = radius;
        this.centerPt = {};
        this.isCentered = false;
        this.connectPoints = false;
        this.maxRadials = Math.floor(1 / arc);
        this.arcRange = [
            1,
            1
        ];
        this.stepRange = [
            1,
            1
        ];
        this.radiusRange = [
            1,
            1
        ];
        this.arcChangeRepeat = [
            1,
            1
        ];
        this.radiusChangeRepeat = [
            1,
            1
        ];
        this.arcChange = 0;
        this.stepChange = 0;
        this.radiusChange = 0;
    }
    setCenterPt(centerPt) {
        this.centerPt = centerPt;
        return this;
    }
    setIsCentered(isCentered) {
        this.isCentered = isCentered;
        return this;
    }
    setConnectPoints(connect) {
        this.connectPoints = connect;
        return this;
    }
    setMaxRadials(max) {
        this.maxRadials = max;
        return this;
    }
    // Take an array of two ints, will use those to randomize arc size
    setArcRange(arcRange) {
        this.arcRange = arcRange;
        return this;
    }
    // Take an array of two ints, will use those to randomize step
    setStepRange(stepRange) {
        this.stepRange = stepRange;
        return this;
    }
    // Take an array of two ints, will use those to randomize radius
    setRadiusRange(radiusRange) {
        this.radiusRange = radiusRange;
        return this;
    }
    // Take an array of two or more float, 
    // will add them into arc calculations in repeating fashion
    setArcChangeRepeat(arcChangeRepeat) {
        this.arcChangeRepeat = arcChangeRepeat;
        return this;
    }
    // Take an array of two or more float, 
    // will add them into radius calculations in repeating fashion
    setRadiusChangeRepeat(radiusChangeRepeat) {
        this.radiusChangeRepeat = radiusChangeRepeat;
        return this;
    }
    // attenuation factor for arc size, compounds across draws
    setArcChange(arcChange) {
        this.arcChange = arcChange;
        return this;
    }
    // Take an array of two ints, will use those to randomize step
    setStepChange(stepChange) {
        this.stepChange = stepChange;
        return this;
    }
    // Take an array of two ints, will use those to randomize size
    setRadiusChange(radiusChange) {
        this.radiusChange = radiusChange;
        return this;
    }
}

});

parcelRegister("zfzWD", function(module, exports) {

$parcel$export(module.exports, "ShapeRadialSeries", () => $069f5a9d8ab8ef0c$export$887d949ede075ac4);

var $6vtqm = parcelRequire("6vtqm");
class $069f5a9d8ab8ef0c$export$887d949ede075ac4 {
    constructor(shape){
        this.shape = shape;
    }
    getOuterParams(args) {
        let outerParams = [];
        let start, end;
        let arcSize = args.arc;
        let stepSize = args.step;
        let changeRepeat = args.arcChangeRepeat[0];
        let changeArc = 1 + 1 * args.arcChange;
        let changeStep = 1 + 1 * args.stepChange;
        let prevStart = 0;
        for(let i = 0; i < args.maxRadials; i++){
            arcSize = arcSize * changeArc;
            stepSize = stepSize * changeStep;
            start = (0, $6vtqm.roundDecimalPlaces)(prevStart + stepSize * (0, $6vtqm.randomAdjustment)(args.stepRange), 4);
            end = (0, $6vtqm.roundDecimalPlaces)(start + arcSize * changeRepeat * (0, $6vtqm.randomAdjustment)(args.stepRange), 4);
            if (args.isCentered) {
                let neuStart = start + Math.abs(stepSize - arcSize) / 2;
                let neuEnd = (0, $6vtqm.roundDecimalPlaces)(neuStart + arcSize, 4);
                outerParams.push(neuStart, neuEnd);
            } else outerParams.push(start, end);
            prevStart = start;
            // This can apply to either group or sequential
            changeRepeat = args.arcChangeRepeat[(i + 1) % args.arcChangeRepeat.length];
        }
        return outerParams;
    }
    getRadialPoints(args, outerParams) {
        let curvePoints = [];
        let radii = [];
        let distance = args.radius;
        let changeSize = 1 + 1 * args.radiusChange;
        let changeRepeat;
        for(let i = 0; i < outerParams.length - 1; i += 2){
            changeRepeat = args.radiusChangeRepeat[i / 2 % args.radiusChangeRepeat.length];
            distance = distance * changeSize;
            radii.push(distance * changeRepeat * (0, $6vtqm.randomAdjustment)(args.radiusRange));
            curvePoints.push((0, $6vtqm.distancePt)(this.shape, args.centerPt, outerParams.at(i), radii.at(-1)));
            curvePoints.push((0, $6vtqm.distancePt)(this.shape, args.centerPt, outerParams.at(i + 1), radii.at(-1)));
        }
        return [
            radii,
            curvePoints
        ];
    }
    buildRadial(args, shape, points, params, radius) {
        let path = ``;
        // Go to start
        path = `${path} M ${args.centerPt.x} ${args.centerPt.y} `;
        // Go to start of outer arc
        path = `${path} L ${points[0].x} ${points[0].y} `;
        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params, radius)} `;
        // Line back to start
        path = `${path} L ${args.centerPt.x} ${args.centerPt.y} `;
        return path;
    }
    getRadialShapes(args, outerParams, outerPoints, radii) {
        let shapePaths = [];
        for(let i = 0; i < outerPoints.length - 1; i += 2){
            let points = outerPoints.slice(i, i + 2);
            let params = outerParams.slice(i, i + 2);
            let radius = radii.at(i / 2);
            shapePaths.push(this.buildRadial(args, this.shape, points, params, radius));
        }
        return shapePaths;
    }
    getRadials(args) {
        let outerParams = this.getOuterParams(args);
        let [radii, radialPoints] = this.getRadialPoints(args, outerParams);
        let radialShapes = this.getRadialShapes(args, outerParams, radialPoints, radii);
        return radialShapes;
    }
}

});

parcelRegister("dWHG1", function(module, exports) {

$parcel$export(module.exports, "ConnectingSeriesArgs", () => $a272926c9258b771$export$212686f3585168d9);
class $a272926c9258b771$export$212686f3585168d9 {
    //
    //// Primary configs - lays out the arc sizes, steps, sides of
    //   the shape length (size) 
    //
    // arc       - Arr[Number] {2} 
    //              The size of the outer part of the shape, 0-1.
    //              Since there are two points of contact use arr (2)
    //              determines sweep size.
    // step       - Arr[Number] {2} 
    //              How much to move along the outer shape before
    //              drawing next arc. Defaults to the same value as size.
    // size       - Arr[Number] {2} 
    //              distance to draw the shape.  
    //              Will do two sets of point calcs so sizing does not 
    //              need to be symmetric. 
    // gap        - The offset between the contact points. defaults to 0.5  
    //
    //// How many to produce, what overall size
    //
    // arcAdjust  - Arr[Number] {2} Normally the arc will draw full size
    //              but you may want to configure this.
    // maxConnect - The max number of connecting shapes to make, defaults 
    //              to 0 (which will calculate on full rotation)
    //
    //// Grow/shrink attenuations params. Applied after each individual 
    //   shape so will continually change.  
    //   positive grows, negative shirnks.  
    //
    // arcChange    - [2] Optional values to shrink/grow the outer shape size.
    //                Defaults to none (0). Negative grows, pos shrinks.
    // stepChange   - [2] Optional values to shrink/grow step between shapes.
    // sizeChange   - [2] Optional value to shrink/grow the shape
    //                   length between the points (not the end arcs, 
    //                   the connecting lines)
    //
    // arcChangeRepeat - n x 2 - repeat some sort of grow/shrink of the arcs
    // stepChangeRepeat - n x 2 - repeat some sort of grow/shink of the steps
    //
    constructor(arc, step, size, gap){
        // Base args that will be adjusted by the others
        this.arc = arc;
        this.size = size;
        this.step = step;
        this.gap = gap;
        // Adjusting arguments
        this.connectPoints = false;
        this.maxConnect = 1 / arc[0];
        this.arcAdjust = [
            1,
            1
        ];
        this.arcChange = [
            0,
            0
        ];
        this.stepChange = [
            0,
            0
        ];
        this.sizeChange = [
            0,
            0
        ];
        // Repeated - meaning they do not compound, but can do some
        // repeating adjustment to arc/step sizes
        this.arcChangeRepeat = [
            [
                1,
                1
            ]
        ];
        this.stepChangeRepeat = [
            [
                1,
                1
            ]
        ];
    }
    setMaxConnect(maxConnect) {
        this.maxConnect = maxConnect;
        return this;
    }
    setArcAdjust(adjust) {
        this.arcAdjust = adjust;
        return this;
    }
    setArcChange(arcChange) {
        this.arcChange = arcChange;
        return this;
    }
    setStepChange(stepChange) {
        this.stepChange = stepChange;
        return this;
    }
    setSizeChange(sizeChange) {
        this.sizeChange = sizeChange;
        return this;
    }
    setArcChangeRepeat(repeats) {
        this.arcChangeRepeat = repeats;
        return this;
    }
    setStepChangeRepeat(repeats) {
        this.stepChangeRepeat = repeats;
        return this;
    }
    setConnectPoints(connect) {
        this.connectPoints = connect;
        return this;
    }
}

});

parcelRegister("eWODf", function(module, exports) {

$parcel$export(module.exports, "ShapeConnectSeries", () => $ae1dc1f299e78d5f$export$ca11440eb6436acc);

var $6vtqm = parcelRequire("6vtqm");
class $ae1dc1f299e78d5f$export$ca11440eb6436acc {
    constructor(shape){
        this.shape = shape;
    }
    // Determine the parameter for the each end of the object on the shape 
    // Not doing any size calculations yet, so just need the arc and step information
    // args - An instance of the `ConnectingShapeArgs` object
    getShapeOuterParams(args) {
        let outerParams = [];
        let start, end, arcSize, stepSize;
        let arcRepeat, stepRepeat;
        let arcReps = args.arcChangeRepeat.length;
        let stepReps = args.stepChangeRepeat.length;
        let changeStep = [
            1,
            1
        ];
        let changeArc = [
            1,
            1
        ];
        // Only apply it to the leading part of the shape
        let prevStart = [
            0,
            args.gap
        ];
        for(let k = 0; k < args.maxConnect; k++)for(let i = 0; i < 2; i++){
            // Repeats apply to both sequential and group
            arcRepeat = args.arcChangeRepeat[k % arcReps][i];
            stepRepeat = args.stepChangeRepeat[k % stepReps][i];
            arcSize = args.arc[i] * changeArc[i];
            stepSize = args.step[i] * changeStep[i];
            start = (0, $6vtqm.roundDecimalPlaces)(prevStart[i] + stepSize * stepRepeat, 4);
            end = (0, $6vtqm.roundDecimalPlaces)(start + arcSize * arcRepeat, 4);
            outerParams.push(start, end);
            // Do these every loop when not using groups
            prevStart[i] = start;
            changeArc[i] += changeArc[i] * args.arcChange[i];
            changeStep[i] += changeStep[i] * args.stepChange[i];
        }
        return outerParams;
    }
    getConnectingPoints(args, outerParams) {
        let curvePoints = [];
        // Extents are analogous to the distances but serve to tell 
        // the shapes involved how to scale the relative arcs
        let extents = [];
        let distanceZero, distanceOne;
        let changeSize = [
            1,
            1
        ];
        let sizes = args.size.slice(0);
        for(let i = 0; i < outerParams.length - 3; i += 4){
            distanceZero = sizes[0] * changeSize[0];
            distanceOne = sizes[1] * changeSize[1];
            extents = extents.concat([
                changeSize[0] * args.arcAdjust[0],
                changeSize[1] * args.arcAdjust[1]
            ]);
            // These point will be from higher to lower params,
            // forming the start arc of the shape
            curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, outerParams[i + 3], outerParams[i], distanceZero));
            curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, outerParams[i + 2], outerParams[i + 1], distanceZero));
            // and these will be from lower to higher params,
            // the end arc
            curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, outerParams[i + 1], outerParams.at(i + 2), distanceOne));
            curvePoints.push((0, $6vtqm.distanceConnect)(this.shape, outerParams[i], outerParams[i + 3], distanceOne));
            changeSize[0] += changeSize[0] * args.sizeChange[0];
            changeSize[1] += changeSize[1] * args.sizeChange[1];
        }
        return [
            extents,
            curvePoints
        ];
    }
    buildConnecting(args, shape, points, params, extent) {
        let path = ``;
        // Go to start
        path = `${path} M ${points[0].x} ${points[0].y} `;
        // Draw arc for lower param edge of the shape
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(0, 2), extent[0])} `;
        // Go to start of outer arc
        path = `${path} L ${points[2].x} ${points[2].y} `;
        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[3].x} ${points[3].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(2, 4), extent[1])} `;
        // Line back to start
        path = `${path} L ${points[0].x} ${points[0].y} `;
        return path;
    }
    getConnectingShapes(args, outerParams, curvePoints, extents) {
        let shapePaths = [];
        for(let i = 0; i < curvePoints.length - 3; i += 4){
            let points = curvePoints.slice(i, i + 4);
            let params = outerParams.slice(i, i + 4);
            let extent = extents.slice(i / 2, i / 2 + 2);
            shapePaths.push(this.buildConnecting(args, this.shape, points, params, extent));
        }
        return shapePaths;
    }
    getConnecting(args) {
        let maxConnect = args.maxConnect === 0 ? 1 / args.step : args.maxConnect;
        args.setMaxConnect(maxConnect);
        let outerParams = this.getShapeOuterParams(args);
        let [extents, curvePoints] = this.getConnectingPoints(args, outerParams);
        let connectingShapes = this.getConnectingShapes(args, outerParams, curvePoints, extents);
        return [
            connectingShapes,
            curvePoints
        ];
    }
}

});

parcelRegister("anYB9", function(module, exports) {

$parcel$export(module.exports, "ShapeFillRandomArgs", () => $78fb0eed421f8429$export$36703cc87a46ef20);
class $78fb0eed421f8429$export$36703cc87a46ef20 {
    // layers    - number, How many layers to have  
    // coverage - double; how much of the spaces to cover, base values
    // thickness - how thick to make the layers.  
    //
    // curveRange - array [2] - the range of curves for each layer. 
    // sizeFactors - the size variation within the curves
    //               [2, 4] would indicate the size difference is up to 100%, 
    //               but only in increments of 50%. 
    //               [10, 20] would be 100% range, but 10% increments
    // spacing  - add spacing in between layers
    //
    //
    // coverageRange - Range of coverage to have. Interacts with the
    //                 coverage/attenuate variables to add randomness
    //                 to coverage but not fully determine it.
    //
    // change - double; whether to shrink or grow the filled space.
    //
    // disjointProtection - boolean, if the curve or shape has not connected
    //                      ends, use this to avoid overflow shapes
    //
    // resolution  - double; if you need a custom interval when getting 
    //          shape coordinates, use this
    constructor(layers, coverage, thickness, curveRange){
        this.layers = layers;
        this.coverage = coverage;
        this.thickness = thickness;
        this.curveRange = curveRange;
        this.change = 0;
        this.spacing = 0;
        this.sizeFactors = [
            1,
            1
        ];
        this.coverageRange = [
            1,
            1
        ];
        this.connectPoints = false;
        this.disjointProtection = false;
        this.resolution = 0.01;
    }
    setSizeFactors(factors) {
        this.sizeFactors = factors;
        return this;
    }
    setCoverageRange(range) {
        this.coverageRange = range;
        return this;
    }
    setChange(change) {
        this.change = change;
        return this;
    }
    setConnectPoints(connect) {
        this.connect = connect;
        return this;
    }
    setSpacing(spacing) {
        this.spacing = spacing;
        return this;
    }
    setDisjointProtection(protection) {
        this.disjointProtection = protection;
        return this;
    }
    setHiRes(resolution) {
        this.resolution = resolution;
        return this;
    }
}

});

parcelRegister("c9nt8", function(module, exports) {

$parcel$export(module.exports, "ShapeFillRandom", () => $8d8887bc60dcbf9b$export$fbe12cf4f04b9513);

var $6vtqm = parcelRequire("6vtqm");
// This class deals with filling/expanding shapes 
// based on their parameters and some arguments. 
// Will probably be most aimed at circles but can see what else it might 
// work for
class $8d8887bc60dcbf9b$export$fbe12cf4f04b9513 {
    constructor(shape, centerPt){
        // Each shape much have a defined center point (.cx, .cy) and 
        // have a getCoordinates() method for this to work.  
        this.shape = shape;
        this.centerPt = centerPt;
    }
    // The curve points are a 3 dim array to account for being 
    // different for each input shape, while the params will be the same 
    // for each of them
    getRandomPoints(endsParams, args) {
        let curvePoints = [];
        let distance = 1;
        for (let params of endsParams){
            curvePoints.push([]);
            for(let i = 0; i < params.length - 1; i += 2){
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, this.centerPt, params.at(i), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, this.centerPt, params.at(i + 1), distance));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, this.centerPt, params.at(i + 1), distance + args.thickness));
                curvePoints.at(-1).push((0, $6vtqm.distancePt)(this.shape, this.centerPt, params.at(i), distance + args.thickness));
            }
            distance += args.thickness + args.spacing;
        }
        return curvePoints;
    }
    getCenterParamsRandom(sizes) {
        let centers = [];
        let startLocation = Math.random();
        let pad = (1 - sizes.reduce((a, b)=>a + b)) / sizes.length;
        let adjustedStart = startLocation;
        for (let size of sizes){
            adjustedStart = adjustedStart + size / 2 + pad / 2;
            centers.push((0, $6vtqm.roundDecimalPlaces)(adjustedStart, 5));
            adjustedStart = adjustedStart + size / 2 + pad / 2;
        }
        return centers;
    }
    randomInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    // Size factors indicates how different the size for each curve
    // can be. The range gets normalized but it indicates the relative
    // difference
    randomSizes(curves, coverage, args) {
        let valueArr = [];
        for(let i = 0; i < curves; i++)valueArr.push(this.randomInRange(...args.sizeFactors));
        coverage = coverage === 0 ? Math.min(...args.sizeFactors) / Math.max(...args.sizeFactors) : coverage;
        let total = valueArr.reduce((a, b)=>a + b) * (1 / coverage);
        return valueArr.map((val)=>(0, $6vtqm.roundDecimalPlaces)(val / total, 3));
    }
    getRandomizedEndParams(args) {
        let centerParams = [];
        let endParams = [];
        // Use a reduction factor from the initial, not from the 
        // current since that will end up being asymptotic
        for(let i = 0; i < args.layers; i++){
            let curveCount = this.randomInRange(...args.curveRange);
            let change = 1 + args.change * i;
            let coverage = args.coverageRange.length === 2 ? this.randomInRange(...args.coverageRange) / Math.max(...args.coverageRange) * args.coverage : args.coverage;
            if (coverage * change > 1) change = 1 / coverage;
            let sizes = this.randomSizes(curveCount, coverage, args);
            endParams.push([]);
            centerParams.push(this.getCenterParamsRandom(sizes));
            let n = 0;
            for (let centerParam of centerParams.at(-1)){
                let halfSize = sizes.at(n) * change / 2;
                let start = centerParam - halfSize < 0 ? centerParam + 1 - halfSize : centerParam - halfSize;
                let end = centerParam + halfSize;
                // If disjoint protection is in place, make sure we DONT
                // end up with values crossing over the start/end 
                // of the shape, eg 0.95 to 1.03 or 1.98 to 2.11
                if (args.disjointProtection) {
                    let [boundStart, boundEnd] = this.calculateIndexBounds(start, end);
                    endParams.at(i).push((0, $6vtqm.roundDecimalPlaces)(boundStart, 5));
                    endParams.at(i).push((0, $6vtqm.roundDecimalPlaces)(boundEnd, 5));
                } else {
                    endParams.at(i).push((0, $6vtqm.roundDecimalPlaces)(start, 5));
                    endParams.at(i).push((0, $6vtqm.roundDecimalPlaces)(end, 5));
                }
                n++;
            }
        }
        return [
            centerParams,
            endParams
        ];
    }
    // The purpose of this is to prevent arcs from overflowing 
    // when a series starts and ends at different points
    // is not neat/complete. 
    // instead of going from 0.9 to 1.1 and causing a problem, it will cap 
    // the second value at 1.0.
    calculateIndexBounds(i, i2) {
        i = i % 1;
        i2 = i2 % 1;
        if (i2 < 0.25 && i > 0.75) {
            if (i2 > 1 - i) i = 0.001;
            else i2 = 0.999;
        }
        if (i < 0.25 && i2 > 0.75) {
            if (i > 1 - i2) i2 = 0.001;
            else i = 0.999;
        }
        return [
            i,
            i2
        ];
    }
    buildCurve(shape, pointArr, params, sizeArr, args) {
        let path = ``;
        let [startInnerPt, endInnerPt, startOuterPt, endOuterPt] = pointArr;
        let [sizeInner, sizeOuter] = sizeArr;
        // Go to start
        path = `${path} M ${startInnerPt.x} ${startInnerPt.y} `;
        // draw to inner arc end
        path = args.connectPoints ? `${path} L ${endInnerPt.x} ${endInnerPt.y} ` : `${path} ${shape.getSubCurveRelative(...params, sizeInner, args.resolution)} `;
        // line to outer arc start
        path = `${path} L ${startOuterPt.x} ${startOuterPt.y} `;
        // draw outer arc
        path = args.connectPoints ? `${path} L ${endOuterPt.x} ${endOuterPt.y} ` : `${path} ${shape.getSubCurveRelative(...params.reverse(), sizeOuter, args.resolution)} `;
        // line back to start point
        path = `${path} L ${startInnerPt.x} ${startInnerPt.y} `;
        return path;
    }
    getRandomShapes(curvePoints, endParams, args) {
        let paths = [];
        let n = 0;
        let thickness = args.thickness;
        for (let pointSet of curvePoints){
            let curveParams = endParams.at(n);
            let sizeInner = 1 + n * (thickness + args.spacing);
            let sizeOuter = 1 + ((n + 1) * thickness + n * args.spacing);
            // console.log(`Input random points: ${JSON.stringify(pointSet)}`)
            for(let i = 0; i < pointSet.length - 3; i += 4){
                let params = curveParams.slice(i / 2, i / 2 + 2);
                let points = pointSet.slice(i, i + 4);
                paths.push(this.buildCurve(this.shape, points, params, [
                    sizeInner,
                    sizeOuter
                ], args));
            }
            n++;
        }
        return paths;
    }
    fillShapeRandomArcs(args) {
        args.layers = args.layers > 0 ? args.layers : Math.floor(1 / args.thickness);
        let [centerParams, endParams] = this.getRandomizedEndParams(args);
        let curvePoints = this.getRandomPoints(endParams, args);
        let randomCurves = this.getRandomShapes(curvePoints, endParams, args);
        return [
            randomCurves,
            curvePoints
        ];
    }
}

});

parcelRegister("6sTcQ", function(module, exports) {

$parcel$export(module.exports, "ParameterCircle", () => $4b502e664d4b1d1d$export$7d1894c10ae32bde);

var $6vtqm = parcelRequire("6vtqm");
class $4b502e664d4b1d1d$export$7d1894c10ae32bde {
    constructor(cx, cy, radius){
        this.cx = cx;
        this.cy = cy;
        this.centerPt = {
            'x': cx,
            'y': cy
        };
        this.r = radius;
    }
    // I jettissoned trying to do everything 0-1 
    // with just looping if i/i2 are > 1 to avoid lots of edge cases
    getSubCurveRelative(i, i2, sizing, resolution = 0.01) {
        let subCurve = ``;
        let sign = i2 > i ? 1 : -1;
        let diff = Math.abs(i2 - i);
        let step = (0, $6vtqm.roundDecimalPlaces)(Math.abs(diff) > resolution ? sign * resolution : diff * sign, 3);
        let prevPt = this.getCoordinates(i);
        let loc = step;
        while(Math.abs(loc) <= diff){
            let nextPt = this.getCoordinates(i + loc);
            subCurve = `${subCurve} l ${(0, $6vtqm.roundDecimalPlaces)(sizing * (nextPt.x - prevPt.x), 4)} ${(0, $6vtqm.roundDecimalPlaces)(sizing * (nextPt.y - prevPt.y), 4)} `;
            prevPt = nextPt;
            loc = (0, $6vtqm.roundDecimalPlaces)(loc + step, 3);
        }
        if (loc !== diff) {
            let endPt = this.getCoordinates(i2);
            subCurve = ` ${subCurve} l ${(0, $6vtqm.roundDecimalPlaces)(sizing * (endPt.x - prevPt.x), 3)} ${(0, $6vtqm.roundDecimalPlaces)(sizing * (endPt.y - prevPt.y), 3)}`;
        }
        return subCurve;
    }
    getSubCurve(i, i2, resolution = 0.01) {
        if (Math.abs(i - i2) > 0.5) {
            console.log(`i: ${i}, i2: ${i2}`);
            if (i < i2) i += 1;
            else i2 += 1;
            console.log(`i: ${i}, i2: ${i2}`);
        }
        let subCurve = ``;
        let sign = i2 > i ? 1 : -1;
        let diff = i2 - i;
        let step = Math.abs(diff) > resolution ? sign * resolution : diff;
        let loc = step;
        while(Math.abs(loc) <= diff){
            let nextPt = this.getCoordinates(i + loc);
            subCurve = `${subCurve} L ${(0, $6vtqm.roundDecimalPlaces)(nextPt.x, 3)} ${(0, $6vtqm.roundDecimalPlaces)(nextPt.y, 3)} `;
            loc += step;
        }
        let endPt = this.getCoordinates(i2);
        subCurve = ` ${subCurve} L ${endPt.x} ${endPt.y}`;
        return subCurve;
    }
    getCoordinates(i) {
        let radians = i * Math.PI * 2;
        let x = (0, $6vtqm.roundDecimalPlaces)(Math.cos(radians) * this.r + this.cx, 3);
        // Inverted to get the correct behavior in svg 
        // since the y coordinates are inverted
        let y = (0, $6vtqm.roundDecimalPlaces)(-Math.sin(radians) * this.r + this.cy, 3);
        return {
            'x': x,
            'y': y
        };
    }
}

});


parcelRegister("lHlxX", function(module, exports) {

$parcel$export(module.exports, "HslColor", () => $fcbe53d85a62aa11$export$5d38e8d142c9a45b);
$parcel$export(module.exports, "HslVary", () => $fcbe53d85a62aa11$export$bdeabbaec80af709);
$parcel$export(module.exports, "randHsl", () => $fcbe53d85a62aa11$export$d443e043be281b94);
$parcel$export(module.exports, "randHslVary", () => $fcbe53d85a62aa11$export$a52c1caff62b7a91);

var $6vtqm = parcelRequire("6vtqm");
class $fcbe53d85a62aa11$export$5d38e8d142c9a45b {
    constructor(hue, sat, light, alpha){
        this.hue = (0, $6vtqm.roundDecimalPlaces)(hue, 1);
        this.sat = (0, $6vtqm.roundDecimalPlaces)(sat, 1);
        this.light = (0, $6vtqm.roundDecimalPlaces)(light, 1);
        this.alpha = (0, $6vtqm.roundDecimalPlaces)(alpha, 3);
    }
    changeHue(chg) {
        this.hue += chg;
        return this;
    }
    changeSaturation(chg) {
        this.sat += chg;
        return this;
    }
    changeLightness(chg) {
        this.light += chg;
        return this;
    }
    changeAlpha(chg) {
        this.alpha += chg;
        return this;
    }
    getHue() {
        return this.hue;
    }
    getSaturation() {
        return this.sat;
    }
    getLightness() {
        return this.light;
    }
    getAlpha() {
        return this.alpha;
    }
    getString() {
        return `hsl(${this.hue}, ${this.sat}%, ${this.light}%, ${this.alpha})`;
    }
}
class $fcbe53d85a62aa11$export$bdeabbaec80af709 {
    constructor(hueVary, satVary, lightVary, alphaVary){
        this.hueVary = hueVary;
        this.satVary = satVary;
        this.lightVary = lightVary;
        this.alphaVary = alphaVary;
    }
    modulateVary(factor) {
        this.hueVary *= factor;
        this.satVary *= factor;
        this.lightVary *= factor;
        this.alphaVary *= factor;
        return this;
    }
    getHueVary() {
        return this.hueVary;
    }
    getSatVary() {
        return this.satVary;
    }
    getLightVary() {
        return this.lightVary;
    }
    getAlphaVary() {
        return this.alphaVary;
    }
}
const $fcbe53d85a62aa11$export$d443e043be281b94 = function(hueRange = [
    0,
    360
], satRange = [
    0,
    100
], lightRange = [
    0,
    100
], alphaRange = [
    0,
    1
]) {
    let hue = (0, $6vtqm.randomFromRange)(...hueRange);
    let sat = (0, $6vtqm.randomFromRange)(...satRange);
    let light = (0, $6vtqm.randomFromRange)(...lightRange);
    let alpha = (0, $6vtqm.randomFromRange)(...alphaRange);
    return new $fcbe53d85a62aa11$export$5d38e8d142c9a45b(hue, sat, light, alpha);
};
const $fcbe53d85a62aa11$export$a52c1caff62b7a91 = function(hueRange = [
    0.2,
    0.4
], satRange = [
    0.1,
    0.2
], lightRange = [
    0.1,
    0.4
], alphaRange = [
    0.05,
    0.15
]) {
    let hue = (0, $6vtqm.randomFromRange)(...hueRange);
    let sat = (0, $6vtqm.randomFromRange)(...satRange);
    let light = (0, $6vtqm.randomFromRange)(...lightRange);
    let alpha = (0, $6vtqm.randomFromRange)(...alphaRange);
    return new $fcbe53d85a62aa11$export$bdeabbaec80af709(hue, sat, light, alpha);
};

});

parcelRegister("fHC8H", function(module, exports) {

$parcel$export(module.exports, "transformScaleSkewY", () => $b6e874d38f3e6cc8$export$485ebff7308da3b5);
$parcel$export(module.exports, "Drawer", () => $b6e874d38f3e6cc8$export$4071300121a182f5);

var $b37p3 = parcelRequire("b37p3");

var $6vtqm = parcelRequire("6vtqm");
const $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b = function(plotElement, ref, attributeMap) {
    let element = document.createElementNS((0, $b37p3.svgNameSpaceURI), `use`);
    let useId = `${ref}-use`;
    element.setAttribute(`href`, `#${ref}`);
    element.setAttribute(`id`, useId);
    for (let [attribute, value] of attributeMap.entries())element.setAttribute(attribute, value);
    plotElement.appendChild(element);
    return [
        useId,
        element
    ];
};
const $b6e874d38f3e6cc8$export$f89e19e593add7bd = function(plotElement, pathD, attributeMap, id) {
    let element = document.createElementNS((0, $b37p3.svgNameSpaceURI), `path`);
    element.setAttribute(`id`, `${id}`);
    element.setAttribute(`d`, pathD);
    for (let [attribute, value] of attributeMap.entries())element.setAttribute(attribute, value);
    plotElement.appendChild(element);
    return element;
};
const $b6e874d38f3e6cc8$export$8daab6f91f7ff730 = function(plotElement, cx, cy, r, attributeMap, id) {
    let element = document.createElementNS((0, $b37p3.svgNameSpaceURI), `circle`);
    element.setAttribute(`id`, `${id}`);
    element.setAttribute(`cx`, cx);
    element.setAttribute(`cy`, cy);
    element.setAttribute(`r`, r);
    for (let [attribute, value] of attributeMap.entries())element.setAttribute(attribute, value);
    plotElement.appendChild(element);
    return element;
};
const $b6e874d38f3e6cc8$var$createMorphologyElem = function(in1, operator, changeRadius, resultName) {
    let feMorphology = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feMorphology');
    feMorphology.setAttribute('in', in1);
    feMorphology.setAttribute('operator', operator);
    feMorphology.setAttribute('radius', changeRadius);
    feMorphology.setAttribute('result', resultName);
    return feMorphology;
};
const $b6e874d38f3e6cc8$var$createFloodElem = function(floodColor, floodOpacity, resultName) {
    let feFlood = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feFlood');
    feFlood.setAttribute('flood-color', floodColor);
    feFlood.setAttribute('flood-opacity', floodOpacity);
    feFlood.setAttribute('result', resultName);
    return feFlood;
};
const $b6e874d38f3e6cc8$var$createBlurElem = function(in1, stdDev, resultName) {
    let feGaussianBlur = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feGaussianBlur');
    feGaussianBlur.setAttribute('in', in1);
    feGaussianBlur.setAttribute('stdDeviation', stdDev);
    feGaussianBlur.setAttribute('result', resultName);
    return feGaussianBlur;
};
const $b6e874d38f3e6cc8$var$createDisplacementMap = function(in1, in2, resultName, scale = 5, noiseType = 'turbulence') {
    let feDisplacementMap = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feDisplacementMap');
    feDisplacementMap.setAttribute('in', in1);
    feDisplacementMap.setAttribute('in2', in2);
    feDisplacementMap.setAttribute('scale', scale);
    feDisplacementMap.setAttribute('result', resultName);
    // You should not need to modify these; feTurbulence for 
    // the RGB channels should be variable in all directions
    feDisplacementMap.setAttribute('xChannelSelector', 'R');
    feDisplacementMap.setAttribute('yChannelSelector', 'B');
    return feDisplacementMap;
};
const $b6e874d38f3e6cc8$var$createTurbulence = function(resultName, baseFreq = '2 3.5', octaves = 5, type = 'turbulence') {
    let turbulence = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feTurbulence");
    turbulence.setAttribute('type', type);
    turbulence.setAttribute('baseFrequency', baseFreq);
    turbulence.setAttribute('numOctaves', octaves);
    turbulence.setAttribute('result', resultName);
    turbulence.setAttribute('seed', Math.round(Math.random() * 5000));
    return turbulence;
};
const $b6e874d38f3e6cc8$var$createSpecularLight = function(inputName, resultName, constant, exponent, surfaceScale, lightColor) {
    let specularLight = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feSpecularLighting");
    specularLight.setAttribute('in', inputName);
    specularLight.setAttribute('result', resultName);
    specularLight.setAttribute('specularConstant', constant);
    specularLight.setAttribute('specularExponent', exponent);
    specularLight.setAttribute('surfaceScale', surfaceScale);
    specularLight.setAttribute('lighting-color', lightColor);
    return specularLight;
};
const $b6e874d38f3e6cc8$var$createDiffuseLight = function(inputName, resultName, constant, surfaceScale, lightColor) {
    let diffuseLight = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feDiffuseLighting");
    diffuseLight.setAttribute('in', inputName);
    diffuseLight.setAttribute('result', resultName);
    diffuseLight.setAttribute('diffuseConstant', constant);
    diffuseLight.setAttribute('surfaceScale', surfaceScale);
    diffuseLight.setAttribute('lighting-color', lightColor);
    return diffuseLight;
};
const $b6e874d38f3e6cc8$var$addPointLight = function(lightingElement, x, y, z) {
    let pointLight = document.createElementNS((0, $b37p3.svgNameSpaceURI), "fePointLight");
    pointLight.setAttribute('x', x);
    pointLight.setAttribute('y', y);
    pointLight.setAttribute('z', z);
    lightingElement.appendChild(pointLight);
};
const $b6e874d38f3e6cc8$var$addDistantLight = function(lightingElement, azimuth, elevation) {
    let pointLight = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feDistantLight");
    pointLight.setAttribute('azimuth', azimuth);
    pointLight.setAttribute('elevation', elevation);
    lightingElement.appendChild(pointLight);
};
const $b6e874d38f3e6cc8$var$addSpotLight = function(lightingElement, x, y, z, coneAngle) {
    let pointLight = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feSpotLight");
    pointLight.setAttribute('x', x);
    pointLight.setAttribute('y', y);
    pointLight.setAttribute('z', z);
    pointLight.setAttribute('limitingConeAngle', coneAngle);
    lightingElement.appendChild(pointLight);
};
const $b6e874d38f3e6cc8$var$createCompositeElem = function(operator, in1, in2, resultName) {
    let feComposite = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feComposite');
    feComposite.setAttribute('operator', operator);
    feComposite.setAttribute('in', in1);
    feComposite.setAttribute('in2', in2);
    feComposite.setAttribute('result', resultName);
    return feComposite;
};
const $b6e874d38f3e6cc8$var$createCompositeLight = function(operator, in1, in2, resultName) {
    let feComposite = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feComposite');
    feComposite.setAttribute('operator', operator);
    feComposite.setAttribute('in', in1);
    feComposite.setAttribute('in2', in2);
    feComposite.setAttribute('result', resultName);
    feComposite.setAttribute('k1', 0);
    feComposite.setAttribute('k2', 1);
    feComposite.setAttribute('k3', 1);
    feComposite.setAttribute('k4', 0);
    return feComposite;
};
const $b6e874d38f3e6cc8$var$createBlendElem = function(mode, in1, in2, resultName) {
    let feBlend = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feBlend');
    feBlend.setAttribute('mode', mode);
    feBlend.setAttribute('in', in1);
    feBlend.setAttribute('in2', in2);
    feBlend.setAttribute('result', resultName);
    return feBlend;
};
// TODO: make the R/G/B values configurable. 
//       Maybe using different combos there would give better 
//       randomization results (and reduce holes)
const $b6e874d38f3e6cc8$var$createColorMatrixAlpha = function(input, resultName, intensityVector) {
    let feColorMatrix = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feColorMatrix');
    feColorMatrix.setAttribute('in', input);
    feColorMatrix.setAttribute('result', resultName);
    feColorMatrix.setAttribute('values', `
                            1 0 0 0 0
                            0 1 0 0 0 
                            0 0 1 0 0
                            ${intensityVector} 0
                            `);
    return feColorMatrix;
};
// Allow creation of the full color matrix,
// you need to specify all values
const $b6e874d38f3e6cc8$var$createFullColorMatrix = function(input, resultName, colorMat) {
    let feColorMatrix = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feColorMatrix');
    feColorMatrix.setAttribute('in', input);
    feColorMatrix.setAttribute('result', resultName);
    feColorMatrix.setAttribute('values', `
                            ${colorMat}
                            `);
    return feColorMatrix;
};
// Very useful to do transforms. 
// The origin allows scaling from locations other than the 
// regular origin
const $b6e874d38f3e6cc8$export$5a26e3b3d26ddeb7 = function(elements, origin, scaleNums) {
    for (let element of elements){
        element.setAttribute('transform-origin', origin);
        element.setAttribute('transform', `scale(${scaleNums})`);
    }
};
const $b6e874d38f3e6cc8$export$485ebff7308da3b5 = function(elements, origin, scaleNums, skewX, skewY, rotate) {
    for (let element of elements){
        let transformStr = ``;
        if (origin) element.setAttribute('transform-origin', origin);
        if (scaleNums) transformStr += `scale(${scaleNums}) `;
        if (skewY) transformStr += `skewY(${skewY}) `;
        if (skewX) transformStr += `skewX(${skewX}) `;
        if (rotate) transformStr += `rotate(${rotate}) `;
        element.setAttribute('transform', transformStr);
    }
};
// Give the filter a wide range so I don't get 
// edge effects
const $b6e874d38f3e6cc8$var$setFilterRange = function(filterElement) {
    filterElement.setAttribute('x', '-500%');
    filterElement.setAttribute('y', '-500%');
    filterElement.setAttribute('width', '1000%');
    filterElement.setAttribute('height', '1000%');
};
// Uses turbulence to displace an input
const $b6e874d38f3e6cc8$var$createTurbulenceDisplacement = function(freq, octaves, displacement = 1, inputName = 'SourceGraphic', noiseType = 'turbulence') {
    let filters = [];
    filters.push($b6e874d38f3e6cc8$var$createTurbulence('turbulence-displace-1', freq, octaves, noiseType));
    filters.push($b6e874d38f3e6cc8$var$createDisplacementMap(inputName, 'turbulence-displace-1', 'turbulence-displace-result', displacement));
    return filters;
};
// Uses turbulence to displace an input
const $b6e874d38f3e6cc8$var$createSpecularPointLight = function(resultName, constant, exponent, surfaceScale, lightColor, x, y, z, inputName = 'SourceGraphic', composite = 'SourceGraphic') {
    let filters = [];
    filters.push($b6e874d38f3e6cc8$var$createSpecularLight(inputName, resultName, constant, exponent, surfaceScale, lightColor));
    $b6e874d38f3e6cc8$var$addPointLight(filters.at(-1), x, y, z);
    filters.push($b6e874d38f3e6cc8$var$createCompositeLight('arithmetic', resultName, composite, 'spec-light-result'));
    return filters;
};
const $b6e874d38f3e6cc8$var$createDiffusePointLight = function(resultName, constant, surfaceScale, x, y, z, lightColor, inputName = 'SourceGraphic', composite = 'SourceGraphic') {
    let filters = [];
    filters.push($b6e874d38f3e6cc8$var$createDiffuseLight(inputName, resultName, constant, surfaceScale, lightColor));
    $b6e874d38f3e6cc8$var$addPointLight(filters.at(-1), x, y, z);
    filters.push($b6e874d38f3e6cc8$var$createCompositeLight('arithmetic', resultName, composite, 'spec-light-result'));
    return filters;
};
// Composites turbulence with another input 
// to add variation to an element
// Had to use two layers of Blur to get the randomized pattern to not 
// have a very grid/dot like bias. Still unclear on exactly why that 
// happens, but it has to do with the turbulence frequencies and compositing.
const $b6e874d38f3e6cc8$var$createTurbulenceComposite = function(freq, octaves, inputName = 'SourceGraphic', intensityVector = `0.63 0.81 0.75 2.5`, noiseType = 'turbulence') {
    let filters = [];
    filters.push($b6e874d38f3e6cc8$var$createTurbulence('turbulence-composite-1', freq, octaves, noiseType));
    filters.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-composite-1', 0.03, 'blur-result-1'));
    filters.push($b6e874d38f3e6cc8$var$createColorMatrixAlpha('blur-result-1', 'turbulence-intensify', intensityVector));
    filters.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-intensify', 0.00, 'blur-result-2'));
    filters.push($b6e874d38f3e6cc8$var$createCompositeElem('in', inputName, 'blur-result-2', 'turbulence-composite-result'));
    return filters;
};
class $b6e874d38f3e6cc8$export$4071300121a182f5 {
    constructor(plotElement, rootId){
        this.rootId = rootId;
        this.plotElement = plotElement;
        this.defsElement = plotElement.querySelector('defs');
        this.counter = 0;
        this.gradientCounter = 0;
        this.filterCounter = 0;
    }
    addLabel(labelText, x = 0, y = 5, width = 30) {
        let element = document.createElementNS((0, $b37p3.svgNameSpaceURI), `text`);
        element.setAttribute(`id`, labelText.slice(0, 30));
        element.setAttribute(`x`, x);
        element.setAttribute(`y`, y);
        element.classList.add(`label-text`);
        element.textContent = labelText;
        this.plotElement.appendChild(element);
    }
    blurFilter(inputElements, blur = 0.02, inputName = 'SourceGraphic') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let filterElements = [];
        let id = `blur-only-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let blurId = `blur-${this.filterCounter}`;
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem(inputName, blur, blurId));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    erodeAndDistortFilter(inputElements, freq, octaves, erode = 0.5, displacement = 0.2, blur = 0.02, inputName = 'SourceGraphic', noiseType = 'turbulence') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `erode-distort-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let filterElements = [];
        let erodeId = `erode-${this.filterCounter}`;
        filterElements.push($b6e874d38f3e6cc8$var$createMorphologyElem(inputName, 'erode', erode, erodeId));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, erodeId, noiseType));
        let blurId = `blur-${this.filterCounter}`;
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', blur, blurId));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // shadowArgs - args for creating one or both of outer/inner 
    //              shadows
    createShadowFilters(shadowArgs, inputName = 'SourceGraphic') {
        let filters = [];
        let mergeNode, blurId;
        let merge = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feMerge');
        merge.setAttribute('result', 'shadows-result');
        // Grow the element and blur it
        if (shadowArgs.outer) {
            let dilateId = `dilate-${this.filterCounter}`;
            filters.push($b6e874d38f3e6cc8$var$createMorphologyElem(inputName, 'dilate', shadowArgs.grow, dilateId));
            blurId = `blur-${this.filterCounter}`;
            filters.push($b6e874d38f3e6cc8$var$createBlurElem(dilateId, shadowArgs.blurOuter, blurId));
            // Flood the whole area, but then cur to inside the grow/blur
            filters.push($b6e874d38f3e6cc8$var$createFloodElem(shadowArgs.floodColorOuter, shadowArgs.floodOpacityOuter, 'flood-1'));
            filters.push($b6e874d38f3e6cc8$var$createCompositeElem('in', 'flood-1', blurId, 'flood-shadow-1'));
            // Cut out original shape to get outer shadow
            filters.push($b6e874d38f3e6cc8$var$createCompositeElem('out', 'flood-shadow-1', inputName, 'outer-shadow'));
            mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'outer-shadow');
            merge.append(mergeNode);
            this.filterCounter++;
        }
        if (shadowArgs.inner) {
            let erodeId = `erode-${this.filterCounter}`;
            filters.push($b6e874d38f3e6cc8$var$createMorphologyElem(inputName, 'erode', shadowArgs.shrink, erodeId));
            blurId = `blur-${this.filterCounter}`;
            filters.push($b6e874d38f3e6cc8$var$createBlurElem(erodeId, shadowArgs.blurInner, blurId));
            // Flood the whole area, take area outside shrink/blur
            filters.push($b6e874d38f3e6cc8$var$createFloodElem(shadowArgs.floodColorInner, shadowArgs.floodOpacityInner, 'flood-2'));
            filters.push($b6e874d38f3e6cc8$var$createCompositeElem('out', 'flood-2', blurId, 'flood-shadow-2'));
            // Cut inside original shape to get inner shadow
            filters.push($b6e874d38f3e6cc8$var$createCompositeElem('in', 'flood-shadow-2', inputName, 'inner-shadow'));
            mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'inner-shadow');
            merge.append(mergeNode);
            this.filterCounter++;
        }
        // Optionally merge it with the input shape. 
        if (shadowArgs.composite) {
            mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'SourceGraphic');
            merge.append(mergeNode);
        }
        filters.push(merge);
        return filters;
    }
    // Take the input and:
    // - adds displacement with turbulence
    // - blurs the results 
    // - composites the blur result with separate turbulence
    // - Adds shadows to give a glow to the displaced/blurred input. 
    // NOTES: could change the order to add shadows before blur, 
    // but I currently like the effect that doing it after achieved.  
    createTurbulenceBlurShadows(shadowArgs, inputElements, freq, freq2, octaves, stdDev, displacement, intensityVector, mergeDisplacement = false) {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-turbulent-shadows-${this.filterCounter}`;
        filter.setAttribute('id', id);
        $b6e874d38f3e6cc8$var$setFilterRange(filter);
        let filterElements = [];
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, 'SourceGraphic'));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', stdDev, 'blur-displace'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq2, octaves, 'blur-displace', intensityVector));
        filterElements = filterElements.concat(this.createShadowFilters(shadowArgs, 'turbulence-composite-result'));
        if (mergeDisplacement) {
            let merge = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feMerge');
            merge.setAttribute('result', 'merged-result');
            let mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'turbulence-composite-result');
            merge.append(mergeNode);
            mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'shadows-result');
            merge.append(mergeNode);
            filterElements.push(merge);
        }
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take the input and:
    // - adds shadows (inner/outer) according to config
    // - composites the original with turbulence.
    // - blurs the output 
    createBlurShadowComposite(inputElements, shadowArgs, freq, octaves, stdDev, intensityVector, over = true) {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-shadows-and-composite-blur-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let filterElements = [];
        let merge = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'feMerge');
        merge.setAttribute('result', 'blur-shadow-composite-result');
        // Using the plain Turbulence Composite, could shift to the double, but it would 
        // need some work. 
        filterElements = filterElements.concat(this.createShadowFilters(shadowArgs, 'SourceGraphic'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq, octaves, 'SourceGraphic', intensityVector));
        // filterElements.push(createBlurElem('turbulence-composite-result', stdDev, 'blur-double-result'))
        if (over) filterElements.push($b6e874d38f3e6cc8$var$createCompositeElem('over', 'shadows-result', 'turbulence-composite-result', 'shadows-over-1'));
        else {
            let mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'shadows-result');
            merge.append(mergeNode);
            mergeNode = document.createElementNS((0, $b37p3.svgNameSpaceURI), "feMergeNode");
            mergeNode.setAttribute('in', 'turbulence-composite-result');
            merge.append(mergeNode);
            filterElements.push(merge);
        }
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take a background as the input, this generates a pattern 
    //   on that background.
    // - The frequencies and color Matrix will both be extremely 
    //   important. 
    createTurbulencePattern(inputElements, freq, octaves, colorMatrix, noiseType = 'turbulence') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-create-pattern-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let filterElements = [];
        filterElements.push($b6e874d38f3e6cc8$var$createTurbulence('turbulence-pattern', freq, octaves, noiseType));
        filterElements.push($b6e874d38f3e6cc8$var$createFullColorMatrix('turbulence-pattern', 'pattern-creation-colorMat', colorMatrix));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take the input and:
    // - blurs the input 
    // - composites the blur result with turbulence.
    createBlurComposite(inputElements, freq, octaves, stdDev, intensityVector) {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-blur-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let filterElements = [];
        // Using the plain Turbulence Composite, could shift to the double, but it would 
        // need some work. 
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq, octaves, 'SourceGraphic', intensityVector));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('double-turbulence-result', stdDev, 'blur-double-result'));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take the input and:
    // - adds displacement with turbulence
    // - blurs the results 
    createTurbulenceBlur(inputElements, freq, octaves, stdDev, displacement = 1) {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-turbulent-blur-${this.filterCounter}`;
        filter.setAttribute('id', id);
        // Very useful if you are having filters hit hard edges; 
        // this expands the filter way beyond an edge
        $b6e874d38f3e6cc8$var$setFilterRange(filter);
        let filterElements = [];
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, 'SourceGraphic'));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', stdDev, 'blur-displace'));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take the input and:
    // - adds displacement with turbulence
    // - blurs the results 
    // - composites the blur result with separate turbulence
    createTurbulenceBlurComposite(inputElements, freq, freq2, octaves, stdDev, displacement = 1, intensityVector, noiseType = 'turbulence') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-turbulence-${this.filterCounter}`;
        filter.setAttribute('id', id);
        let filterElements = [];
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, 'SourceGraphic'));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', stdDev, 'blur-displace'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq2, octaves, 'blur-displace', intensityVector, noiseType));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Take the input and:
    // - adds displacement with turbulence
    // - blurs the results 
    // - composites the blur result with separate turbulence
    createTurbulenceBlurLightComposite(inputElements, freq, freq2, octaves, stdDev, displacement = 1, intensityVector, noiseType = 'turbulence', constant, exponent, surfaceScale, x, y, z, lightColor = 'white') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-turbulence-${this.filterCounter}`;
        filter.setAttribute('id', id);
        $b6e874d38f3e6cc8$var$setFilterRange(filter);
        let filterElements = [];
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, 'SourceGraphic'));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', stdDev, 'blur-displace'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq2, octaves, 'blur-displace', intensityVector, noiseType));
        // Only purpose is to be used with the specular light
        // It needs something solid to shine the light on
        filterElements.push($b6e874d38f3e6cc8$var$createFloodElem('black', 0.0, 'flood-test-light'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createSpecularPointLight('lighting-result', constant, exponent, surfaceScale, lightColor, x, y, z, 'flood-test-light', 'turbulence-composite-result'));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
        return filter;
    }
    // TODO: 
    // This is very different than the specular / point light. 
    // It seems to darken everything by default, could not get 
    // it to work with my input, just ended up turning most 
    // of it black
    createTurbulenceDiffuseLightComposite(inputElements, freq, freq2, octaves, stdDev, displacement = 1, intensityVector, noiseType = 'turbulence', constant, surfaceScale, x, y, z, lightColor = 'white') {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        let id = `filter-turb-light-diffuse-${this.filterCounter}`;
        filter.setAttribute('id', id);
        $b6e874d38f3e6cc8$var$setFilterRange(filter);
        let filterElements = [];
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceDisplacement(freq, octaves, displacement, 'SourceGraphic'));
        filterElements.push($b6e874d38f3e6cc8$var$createBlurElem('turbulence-displace-result', stdDev, 'blur-displace-12'));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createTurbulenceComposite(freq2, octaves, 'blur-displace-12', intensityVector, noiseType));
        filterElements = filterElements.concat($b6e874d38f3e6cc8$var$createDiffusePointLight('lighting-result', constant, surfaceScale, x, y, z, lightColor, 'blur-displace-12', 'turbulence-composite-result'));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
        this.filterCounter++;
    }
    // Adds a shadow filter
    // inputElements - Shapes (or group/element) the filter is applied to 
    // shadowArgs  - Arguments that configure exactly what the shadows will look like
    addShadowFilters(inputElements, shadowArgs, id = `filter-shadow`) {
        inputElements = (0, $6vtqm.ensureIsArray)(inputElements);
        let filterElements = [];
        let svgDefs = this.plotElement.querySelector('defs');
        let filter = document.createElementNS((0, $b37p3.svgNameSpaceURI), "filter");
        id = `${id}-${this.filterCounter}`;
        filter.setAttribute('id', id);
        $b6e874d38f3e6cc8$var$setFilterRange(filter);
        filterElements = filterElements.concat(this.createShadowFilters(shadowArgs));
        filterElements.forEach((filterElement)=>filter.append(filterElement));
        svgDefs.appendChild(filter);
        inputElements.forEach((shape)=>shape.setAttribute(`filter`, `url(#${id})`));
    }
    createLinearGradient(svgElement, color1, color2, startX, startY, endX, endY, offset1, offset2) {
        let svgDefs = svgElement.querySelector('defs');
        let gradient = document.createElementNS((0, $b37p3.svgNameSpaceURI), "linearGradient");
        let id = `linear-gradient-${this.gradientCounter}`;
        gradient.setAttribute('id', id);
        gradient.setAttribute('x1', startX);
        gradient.setAttribute('y1', startY);
        gradient.setAttribute('x2', endX);
        gradient.setAttribute('y2', endY);
        let stop1 = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'stop');
        stop1.setAttribute('offset', offset1);
        stop1.setAttribute('stop-color', color1);
        gradient.append(stop1);
        // Reduce saturation and lightness to get the
        // end color that will create the shadow effect
        let stop2 = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'stop');
        stop2.setAttribute('offset', offset2);
        stop2.setAttribute('stop-color', color2);
        gradient.append(stop2);
        // Add to the defs element
        svgDefs.appendChild(gradient);
        this.gradientCounter++;
        return id;
    }
    // Hue goes 0-360, so it gets its own method here
    randHue(hueBase, hueVary) {
        let rand = (Math.random() * 2 - 1) * hueVary;
        let hue = hueBase + rand * 360;
        hue = hue < 0 ? 360 + hue : hue % 360;
        return (0, $6vtqm.roundDecimalPlaces)(Math.max(0, hue), 1);
    }
    randSatLight(base, vary) {
        let rand = (Math.random() * 2 - 1) * vary;
        return (0, $6vtqm.roundDecimalPlaces)(Math.max(0, Math.min(100, base + rand * 100)), 1);
    }
    getRandHsl(hslBase, varyHsl) {
        let hue = this.randHue(hslBase.getHue(), varyHsl.getHueVary());
        let sat = this.randSatLight(hslBase.getSaturation(), varyHsl.getSatVary());
        let light = this.randSatLight(hslBase.getLightness(), varyHsl.getLightVary());
        let hsl = `hsl(${hue}, ${sat}%, ${light}%, ${hslBase.getAlpha()})`;
        return hsl;
    }
    // Select the plot and group element. 
    // Depending on the config, they may be the same thing
    selectPlotElements(group, asDef, groups = 1, id = '') {
        let plotElements = [];
        let groupElements = [];
        if (group) for(let i = 0; i < groups; i++){
            let groupElement = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'g');
            this.plotElement.append(groupElement);
            groupElement.setAttribute('id', `${id}`);
            groupElements.push(groupElement);
            plotElements.push(asDef ? this.defsElement : groupElement);
        }
        else {
            let plotElement = asDef ? this.defsElement : this.plotElement;
            groupElements.push(this.plotElement);
        }
        return [
            plotElements,
            groupElements
        ];
    }
    drawPathGroups(baseId, pathGroupDs, stylingMaps, asDef, group = true, groups = 1) {
        let n = 0;
        let [plotElements, groupElements] = this.selectPlotElements(group, asDef, groups, baseId);
        let ids = [];
        let elements = [];
        pathGroupDs = (0, $6vtqm.ensureIsArray)(pathGroupDs);
        for (let pathGroup of pathGroupDs){
            let plotUse = groupElements[n % groupElements.length];
            let plotElement = plotElements[n % plotElements.length];
            let idx = n % stylingMaps.length;
            ids.push([]);
            let styling = stylingMaps[idx];
            let stylingDirect = asDef ? new Map() : styling;
            for (let path of pathGroup){
                let id = `${baseId}-${this.counter}`;
                ids.at(-1).push(id);
                let rawElement = $b6e874d38f3e6cc8$export$f89e19e593add7bd(plotElement, path, stylingDirect, id);
                if (asDef) {
                    let [useId, element] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(plotUse, id, styling);
                    elements.push(element);
                } else elements.push(rawElement);
                this.counter++;
            }
            n++;
        }
        return [
            groupElements,
            ids
        ];
    }
    drawPathsWithGradients(baseId, pathDs, stylingMap, asDef, hsl, hslVary, offset1 = 0, offset2 = 0, offsetVary = 0, group = true, groups = 1) {
        let [plotElements, groupElements] = this.selectPlotElements(group, asDef, groups, baseId);
        // let plotUse = groupElement
        let ids = [];
        pathDs = (0, $6vtqm.ensureIsArray)(pathDs);
        let n = 0;
        for (let path of pathDs){
            let plotUse = groupElements[n % groupElements.length];
            let plotElement = plotElements[n % plotElements.length];
            let color1 = this.getRandHsl(hsl, hslVary);
            let color2 = this.getRandHsl(hsl, hslVary);
            let gradientId = this.createLinearGradient(this.plotElement, color1, color2, `0%`, `0%`, `100%`, `100%`, `0%`, `100%`);
            stylingMap.set(`fill`, `url(#${gradientId})`);
            let styling = asDef ? new Map() : stylingMap;
            let id = `${baseId}-${this.counter}`;
            ids.push(id);
            let rawElement = $b6e874d38f3e6cc8$export$f89e19e593add7bd(plotElement, path, styling, id);
            if (asDef) {
                let [useId, element] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(plotUse, id, stylingMap);
            }
            this.counter++;
        }
        return [
            groupElements,
            ids
        ];
    }
    drawPathsColorRand(baseId, pathDs, stylingMap, asDef, hsl, hslVary, cssName, group = true, className = null, randomize = false, groups = 1) {
        let [plotElements, groupElements] = this.selectPlotElements(group, asDef, groups, baseId);
        if (className) groupElements.forEach((group)=>group.setAttribute('class', className));
        let ids = [];
        let elements = [];
        if (randomize) pathDs = pathDs.map((value)=>({
                value: value,
                sort: Math.random()
            })).sort((a, b)=>a.sort - b.sort).map(({ value: value })=>value);
        let n = 0;
        for (let path of pathDs){
            let plotUse = groupElements[n % groupElements.length];
            let plotElement = plotElements[n % plotElements.length];
            let hslRand = this.getRandHsl(hsl, hslVary);
            stylingMap.set(cssName, hslRand);
            let styling = asDef ? new Map() : stylingMap;
            let id = `${baseId}-${this.counter}`;
            ids.push(id);
            let rawElement = $b6e874d38f3e6cc8$export$f89e19e593add7bd(plotElement, path, styling, id);
            if (asDef) {
                let [useId, element] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(plotUse, id, stylingMap);
                elements.push(element);
            } else elements.push(rawElement);
            n++;
            this.counter++;
        }
        return [
            groupElements,
            ids
        ];
    }
    // Draw randomized colors, but goes from start point to an end point
    // with a little variation in between
    drawPathsColorSequenceRand(baseId, pathDs, stylingMap, asDef, hsl, hslVary, subVary, cssName, group = true, randomize = false, groups = 1) {
        let [plotElements, groupElements] = this.selectPlotElements(group, asDef, groups, baseId);
        let ids = [];
        let elements = [];
        if (randomize) pathDs = pathDs.map((value)=>({
                value: value,
                sort: Math.random()
            })).sort((a, b)=>a.sort - b.sort).map(({ value: value })=>value);
        let n = 0;
        let hueStep = hslVary.getHueVary() * 360 / pathDs.length;
        let satStep = hslVary.getSatVary() * 100 / pathDs.length;
        let lightStep = hslVary.getLightVary() * 100 / pathDs.length;
        let alphaStep = hslVary.getAlphaVary() * 1 / pathDs.length;
        hslVary.modulateVary(subVary);
        for (let path of pathDs){
            let plotUse = groupElements[n % groupElements.length];
            let plotElement = plotElements[n % plotElements.length];
            let hslRand = this.getRandHsl(hsl, hslVary);
            stylingMap.set(cssName, hslRand);
            let styling = asDef ? new Map() : stylingMap;
            let id = `${baseId}-${this.counter}`;
            ids.push(id);
            let rawElement = $b6e874d38f3e6cc8$export$f89e19e593add7bd(plotElement, path, styling, id);
            if (asDef) {
                let [useId, element] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(plotUse, id, stylingMap);
                elements.push(element);
            } else elements.push(rawElement);
            hsl.changeHue(hueStep).changeSaturation(satStep).changeLightness(lightStep).changeAlpha(alphaStep);
            n++;
            this.counter++;
        }
        return [
            groupElements,
            ids
        ];
    }
    drawPaths(baseId, pathDs, stylingMap, asDef, group = true, groups = 1) {
        let [plotElements, groupElements] = this.selectPlotElements(group, asDef, groups, baseId);
        let styling = asDef ? new Map() : stylingMap;
        let ids = [];
        let elements = [];
        pathDs = (0, $6vtqm.ensureIsArray)(pathDs);
        let n = 0;
        for (let path of pathDs){
            let plotUse = groupElements[n % groupElements.length];
            let plotElement = plotElements[n % plotElements.length];
            let id = `${baseId}-${this.counter}`;
            ids.push(id);
            let rawElement = $b6e874d38f3e6cc8$export$f89e19e593add7bd(plotElement, path, styling, id);
            if (asDef) {
                let [useId, element] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(plotUse, id, stylingMap);
                elements.push(element);
            } else elements.push(rawElement);
            n++;
            this.counter++;
        }
        return [
            groupElements,
            ids
        ];
    }
    drawCircles(baseId, circles, stylingMap, asDef, groupElement = null) {
        let plotElement = asDef ? this.defsElement : this.plotElement;
        let stylingDirect = asDef ? new Map() : stylingMap;
        circles = (0, $6vtqm.ensureIsArray)(circles);
        let ids = [];
        let elements = [];
        for (let circle of circles){
            let id = `${baseId}-${this.counter}`;
            ids.push(id);
            let drawnCircle = $b6e874d38f3e6cc8$export$8daab6f91f7ff730(plotElement, circle.cx, circle.cy, circle.r, stylingDirect, id);
            let element = drawnCircle;
            if (asDef) {
                let useElement = groupElement === null ? this.plotElement : groupElement;
                let [idRslt, elementRslt] = $b6e874d38f3e6cc8$export$8a2ba38fe3e1710b(useElement, id, stylingMap);
                element = elementRslt;
            }
            elements.push(element);
            this.counter++;
        }
        return [
            elements,
            ids
        ];
    }
    // I use this to move things around when needed
    appendToElement(elements) {
        elements.forEach((element)=>this.plotElement.appendChild(element));
    }
}

});
parcelRegister("b37p3", function(module, exports) {

$parcel$export(module.exports, "svgNameSpaceURI", () => $80b5b79fb98143c4$export$c288ac889cf22ca6);
const $80b5b79fb98143c4$export$c288ac889cf22ca6 = `http://www.w3.org/2000/svg`;

});


parcelRegister("DnWdO", function(module, exports) {

$parcel$export(module.exports, "createGithubLink", () => $0766363ba1e7cde4$export$9ff5a72d6ac542e1);
$parcel$export(module.exports, "createNpmLink", () => $0766363ba1e7cde4$export$754bc47ea3e54980);
$parcel$export(module.exports, "createHomeLink", () => $0766363ba1e7cde4$export$b4683418fd433a3d);

var $b37p3 = parcelRequire("b37p3");

var $lHlxX = parcelRequire("lHlxX");
const $0766363ba1e7cde4$export$9ff5a72d6ac542e1 = function(svgElement, viewBox, xOff, yOff) {
    const linkGroup = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'g');
    const link = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'a');
    link.setAttribute('id', 'github-link');
    link.setAttribute('href', 'https://github.com/jadesrochers');
    const circle = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'circle');
    circle.setAttribute('cx', 12);
    circle.setAttribute('cy', 12.2);
    circle.setAttribute('r', 11.6);
    circle.setAttribute('fill', 'hsla(0, 0%, 0%, 0.0)');
    const path = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'path');
    path.setAttribute('d', "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12");
    path.setAttribute('fill', 'hsla(200, 50%, 40%, 1.0');
    link.appendChild(circle);
    link.appendChild(path);
    linkGroup.appendChild(link);
    let xCoord = viewBox.x - xOff;
    let yCoord = viewBox.y - yOff;
    linkGroup.setAttribute('transform', `translate(${xCoord} ${yCoord}) scale(0.15)`);
    svgElement.appendChild(linkGroup);
// <a href="https://github.com/jadesrochers" class=`no-outline hover` >
//   <circle cx='12' cy='12.2' r='11.6' fill={'#d7dce8'} />
// <path  d={githubpath} fill={'#34363a'} />
// </a>
};
const $0766363ba1e7cde4$export$754bc47ea3e54980 = function(svgElement, viewBox, xOff, yOff) {
    const linkGroup = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'g');
    const link = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'a');
    link.setAttribute('id', 'npm-link');
    link.setAttribute('href', 'https://www.npmjs.com/search?q=%40jadesrochers');
    const rect = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'rect');
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    rect.setAttribute('width', 25.5);
    rect.setAttribute('height', 25.5);
    rect.setAttribute('rx', 2);
    rect.setAttribute('ry', 2);
    rect.setAttribute('fill', 'hsla(0, 0%, 0%, 0.0)');
    const path = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'path');
    path.setAttribute('d', "M1.763 0C.786 0 0 .786 0 1.763v20.474C0 23.214.786 24 1.763 24h20.474c.977 0 1.763-.786 1.763-1.763V1.763C24 .786 23.214 0 22.237 0zM5.13 5.323l13.837.019-.009 13.836h-3.464l.01-10.382h-3.456L12.04 19.17H5.113z");
    path.setAttribute('fill', 'hsla(200, 50%, 40%, 1.0');
    link.appendChild(rect);
    link.appendChild(path);
    linkGroup.appendChild(link);
    let xCoord = viewBox.x - xOff;
    let yCoord = viewBox.y - yOff;
    linkGroup.setAttribute('transform', `translate(${xCoord} ${yCoord}) scale(0.14)`);
    svgElement.appendChild(linkGroup);
};
const $0766363ba1e7cde4$export$b4683418fd433a3d = function(svgElement, viewBox, draw, xOff, yOff, scale = 1) {
    const compassPaths = [
        "M150.039941614 0.479040546029C150.039941614 0.479040546029 150.17429968 15.8233240987 150.17429968 15.8233240987C150.17429968 15.8233240987 150.228560431 15.2920902291 150.228560431 15.2920902291C150.228560431 15.2920902291 150.231661348 15.2920902291 150.231661348 15.2920902291C150.231661348 15.2920902291 151.801590408 30.6896010441 151.801590408 30.6896010441C166.970147999 30.882466424 181.962802647 33.9626768766 195.990109105 39.7691487729C195.990109105 39.7691487729 207.600253606 11.9388064862 207.600253606 11.9388064862C189.360253855 4.35980665777 169.789939653 0.459040532608 150.039941614 0.479040546029C150.039941614 0.479040546029 150.039941614 0.479040546029 150.039941614 0.479040546029",
        "M150.094202365 0.426847328255C130.33420043 0.429847332914 110.774223499 4.34225631566 92.5442249985 11.9372562924C92.5442249985 11.9372562924 104.404482776 39.7169570632 104.404482776 39.7169570632C104.404482776 39.7169570632 104.399831401 39.72005798 104.399831401 39.72005798C118.445788339 33.885360333 133.470600446 30.7869597757 148.670516454 30.5872813749C148.670516454 30.5872813749 150.086450073 16.6987226853 150.086450073 16.6987226853C150.086450073 16.6987226853 150.094202365 0.426847328255 150.094202365 0.426847328255C150.094202365 0.426847328255 150.094202365 0.426847328255 150.094202365 0.426847328255",
        "M65.5 65.66C76.55 54.55 89.69 45.73 104.16 39.7C104.16 39.7 92.58 11.86 92.58 11.86C74.34 19.44 57.78 30.55 43.86 44.56C43.86 44.56 65.5 65.66 65.5 65.66",
        "M44.4 43.89C30.39 57.81 19.45 74.34 11.89 92.57C11.89 92.57 39.75 103.93 39.75 103.93C45.707 89.64 54.4 76.64 65.33 65.67C65.33 65.67 43.77 44.64 43.77 44.64C44.0095 44.4195 44.2497 44.1997 44.4906 43.9807C44.4906 43.9807 44.4085 43.89816 44.4085 43.89816",
        "M11.93346 92.61C4.344732 110.83036 0.444528 130.36842 0.460404 150.10758C0.460404 150.10758 16.6698 149.96443 16.6698 149.96443C16.6698 149.96443 30.709476 148.55305 30.709476 148.55305C30.875116 133.33326 33.958764 118.28282 39.798486 104.20609C39.798486 104.20609 11.936106 92.611323 11.936106 92.611323C11.936106 92.611323 11.93346 92.61 11.93346 92.61",
        "M15.444702 150.10758C15.444702 150.10758 0.460404 150.11358 0.460404 150.11358C0.4809052 169.84745 4.188618 189.38022 11.809098 207.5847C11.809098 207.5847 39.618558 195.70945 39.618558 195.70945C33.781482 181.73064 30.66714 166.76221 30.436938 151.65355C30.436938 151.65355 15.447348 150.11649 15.447348 150.11649C15.447348 150.11649 15.444702 150.10758 15.444702 150.10758",
        "M65.6 234.5C54.47 223.47 45.63 210.35 39.58 195.91C39.58 195.91 11.71 207.49 11.71 207.49C19.311 225.7 30.45 242.23 44.48 256.12C44.48 256.12 65.59 234.5 65.59 234.5",
        "M104.5 260.4C89.99 254.479 76.78 245.76 65.64 234.74C65.64 234.74 44.36 256.12 44.36 256.12C58.38 270.02 75.02 281.02 93.31 288.46C93.31 288.46 104.5 260.4 104.5 260.4",
        "M104.509903362 260.348972039C104.509903362 260.348972039 92.9199121746 288.178802886 92.9199121746 288.178802886C111.16991053 295.742790785 130.740042169 299.618777966 150.490042854 299.598775466C150.490042854 299.598775466 150.308657746 280.672785197 150.308657746 280.672785197C150.308657746 280.672785197 149.860106964 285.090109892 149.860106964 285.090109892C149.860106964 285.090109892 148.274157382 269.383569704 148.274157382 269.383569704C133.24963367 269.151715323 118.396811317 266.089798163 104.509903362 260.348972039C104.509903362 260.348972039 104.509903362 260.348972039 104.509903362 260.348972039",
        "M195.70588839 260.297812205C195.70588839 260.297812205 195.700205139 260.299881246 195.700205139 260.299881246C181.666805327 266.138243373 166.645382532 269.241461992 151.448641524 269.447122623C151.448641524 269.447122623 150.02805653 283.434902975 150.02805653 283.434902975C150.02805653 283.434902975 150.025987489 299.608088799 150.025987489 299.608088799C169.785989424 299.598087549 189.345966354 295.680031617 207.575964855 288.078023092C207.575964855 288.078023092 195.70588839 260.297812205 195.70588839 260.297812205C195.70588839 260.297812205 195.70588839 260.297812205 195.70588839 260.297812205",
        "M234.5 234.5C223.43 245.59 210.28 254.39 195.8 260.4C195.8 260.4 207.33 288.26 207.33 288.26C224.36 281.051 243.16 268.77 255.78 255.88C255.78 255.88 234.49 234.51 234.49 234.51",
        "M260.4 195.94C254.411 210.41 245.62 223.56 234.54 234.64C234.54 234.64 255.77 255.91 255.77 255.91C269.75 241.97 280.91 225.47 288.45 207.23C288.45 207.23 260.4 195.94 260.4 195.94",
        "M300.0564 150.08112C300.0564 150.08112 285.28907 150.2222 285.28907 150.2222C285.28907 150.2222 269.65915 151.82277 269.65915 151.82277C269.47824 166.98964 266.40193 181.98717 260.58866 196.01097C260.58866 196.01097 288.45104 207.59516 288.45104 207.59516C296.03183 189.37216 300.07757 169.79382 300.0564 150.08112C300.0564 150.08112 300.0564 150.08112 300.0564 150.08112",
        "M288.414 92.61C288.414 92.61 288.3437 92.63998 288.3437 92.63998C288.4174 92.795671 288.49026 92.95115 288.56335 93.107264C288.56335 93.107264 260.62159 104.53798 260.62159 104.53798C260.61359 104.52218 260.60679 104.50628 260.59939 104.49038C266.4444 118.48772 269.55875 133.46408 269.78101 148.62566C269.78101 148.62566 284.34195 150.0897 284.34195 150.0897C284.34195 150.0897 299.97981 150.0837 299.97981 150.0837C299.95921 130.34984 296.02404 110.81706 288.40356 92.612585C288.40356 92.612585 288.414 92.61 288.414 92.61",
        "M234.8 65.99C245.87 77.08 254.64 90.24 260.61 104.72C260.61 104.72 288.54 93.29 288.54 93.29C281.036 75.04 269.99 58.45 256.03 44.48C256.03 44.48 234.8 65.99 234.8 65.99",
        "M196.1 39.9C210.58 45.9 223.74 54.69 234.82 65.77C234.82 65.77 256.22 44.51 256.22 44.51C242.28 30.53 225.7 19.45 207.44 11.9C207.44 11.9 196.1 39.9 196.1 39.9",
        "M162.4 137.83C162.4 137.83 158.952 141.343 158.952 141.343C161.177 143.664 162.42 146.753 162.421 149.966C162.42011 153.321 161.066 156.535 158.665 158.881C158.665 158.881 162.503 162.721 162.503 162.721C162.503 162.721 285.103 150.171 285.103 150.171C285.103 150.171 162.403 137.831 162.403 137.831",
        "M140.6 109.679C125.24 113.299 113.24 125.279 109.61 140.619C109.61 140.619 137.74 137.792 137.74 137.792C137.74 137.792 140.606 109.682 140.606 109.682M137.74 137.792C137.74 137.792 141.073 141.193 141.073 141.193C141.0895 141.1753 141.106 141.1575 141.1226 141.1399C141.1226 141.1399 137.7396 137.7919 137.7396 137.7919M159.8596 109.7219C159.8596 109.7219 162.7216 137.7919 162.7216 137.7919C162.7216 137.7919 162.688 137.8249 162.688 137.8249C162.688 137.8249 190.668 140.6389 190.668 140.6389C187.062 125.3589 175.148 113.3989 159.868 109.7189C159.868 109.7189 159.86801 109.7189 159.86801 109.7189M158.72001 158.8489C158.71601 158.8539 158.71101 158.8579 158.70711 158.8629C158.70711 158.8629 162.55811 162.6889 162.55811 162.6889C162.55811 162.6889 158.72011 158.8489 158.72011 158.8489M162.55811 162.6889C162.55811 162.6889 159.72311 190.5989 159.72311 190.5989C175.01311 186.9789 186.97311 175.0789 190.63311 159.8089C190.63311 159.8089 162.55311 162.6849 162.55311 162.6849M141.33311 158.9249C141.33311 158.9249 137.60211 162.6579 137.60211 162.6579C137.60211 162.6579 109.65211 159.7929 109.65211 159.7929C113.31611 175.0729 125.28211 186.9929 140.60211 190.6129C140.60211 190.6129 137.77411 162.5929 137.77411 162.5929C137.77411 162.5929 141.43011 159.0139 141.43011 159.0139C141.39951 158.9857 141.36901 158.9573 141.33861 158.9287C141.33861 158.9287 141.33865 158.92874 141.33865 158.92874",
        "M158.6 158.89C156.266 161.165 153.135 162.439 149.874 162.439C146.696 162.433 143.639 161.218 141.326 159.041C141.326 159.041 137.67 162.62 137.67 162.62C137.67 162.62 150.03 285.02 150.03 285.02C150.03 285.02 162.45 162.72 162.45 162.72C162.45 162.72 158.599 158.894 158.599 158.894",
        "M150.2 15.3C150.2 15.3 137.71 137.8 137.71 137.8C137.71 137.8 141.093 141.148 141.093 141.148C143.435 138.794 146.62 137.469 149.943 137.466C153.392 137.469 156.687 138.896 159.046 141.409C159.046 141.409 162.693 137.8 162.693 137.8C162.693 137.8 150.203 15.3 150.203 15.3",
        "M137.7 137.82C137.7 137.82 15.1 150.14 15.1 150.14C15.1 150.14 137.5 162.69 137.5 162.69C137.5 162.69 141.231 158.957 141.231 158.957C138.773 156.608 137.38 153.359 137.375 149.961C137.379 146.688 138.67 143.548 140.971 141.217C140.971 141.217 137.638 137.816 137.638 137.816",
        "m 175.27356,116.91565 c 0,0 21.51255,-25.620075 21.51255,-25.620075 8.14357,-9.384929 18.48389,-16.690095 32.49628,-19.484776 -0.63093,19.055825 -15.07827,27.387878 -26.27,36.655821 0,0 -19.79673,16.15715 -19.79673,16.15715 0,0 -7.9421,-7.70943 -7.9421,-7.70943",
        "m 116.60648,124.52855 c 0,0 -26.11406,-21.07734 -26.11406,-21.07734 -9.539059,-7.969546 -17.039108,-18.167004 -20.078297,-32.118304 19.093746,0.296978 27.690957,14.574255 37.167487,25.591516 0,0 16.96528,19.897718 16.96528,19.897718 0,0 -7.93265,7.70367 -7.93265,7.70367",
        "m 183.89728,175.23458 c 0,0 25.86846,21.67287 25.86846,21.67287 9.47812,8.2037 16.86105,18.61796 19.67997,32.73876 -19.24729,-0.63551 -27.6647,-15.18281 -37.02612,-26.45848 0,0 -16.31038,-19.94219 -16.31038,-19.94219 0,0 7.78545,-7.99916 7.78545,-7.99916",
        "m 125.24798,183.88571 c 0,0 -21.51254,25.62007 -21.51254,25.62007 -8.143579,9.38493 -18.483901,16.69009 -32.4963,19.48477 0.630948,-19.05583 15.078277,-27.38787 26.269999,-36.65581 0,0 19.887731,-16.45612 19.887731,-16.45612 0,0 7.85501,8.01228 7.85501,8.01228"
    ];
    const linkGroup = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'g');
    const link = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'a');
    link.setAttribute('id', 'home-link');
    link.setAttribute('href', '/');
    link.setAttribute('pointer-events', 'fill');
    const rect = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'rect');
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    rect.setAttribute('width', 305);
    rect.setAttribute('height', 305);
    rect.setAttribute('rx', 2);
    rect.setAttribute('ry', 2);
    rect.setAttribute('fill', 'hsla(0, 0%, 0%, 0.0)');
    link.appendChild(rect);
    const pathElems = [];
    for (let pathD of compassPaths){
        const path = document.createElementNS((0, $b37p3.svgNameSpaceURI), 'path');
        path.setAttribute('d', pathD);
        path.setAttribute('fill', '#224');
        link.appendChild(path);
        pathElems.push(path);
    }
    let hsl = new (0, $lHlxX.HslColor)(200, 75, 35, 0.9);
    let hslVary = new (0, $lHlxX.HslVary)(0.08, 0.13, 0.13, 0.05);
    for (let path of pathElems.slice(0, 16)){
        let hslCur = draw.getRandHsl(hsl, hslVary);
        path.setAttribute('fill', hslCur);
    }
    hsl = new (0, $lHlxX.HslColor)(40, 75, 35, 0.9);
    hslVary = new (0, $lHlxX.HslVary)(0.08, 0.13, 0.13, 0.05);
    for (let path of pathElems.slice(16)){
        let hslCur = draw.getRandHsl(hsl, hslVary);
        path.setAttribute('fill', hslCur);
    }
    let xCoord = viewBox.x - xOff;
    let yCoord = viewBox.y - yOff;
    linkGroup.setAttribute('transform', `translate(${xCoord} ${yCoord}) scale(${0.0125 * scale})`);
    linkGroup.appendChild(link);
    svgElement.appendChild(linkGroup);
};

});


//# sourceMappingURL=congressAgePlot.385c8688.js.map
